import React, {useState, useEffect } from 'react'
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser';
import { InHomeUtils } from './../../util/inhomeUtils';
import {getPerkActualPrice } from './../../containers/midnight/services/dataFormatter';
import * as cartActions from './../../action/cart'
import * as buildProductAction from './../../action/buildProduct';
import { Body, Title } from '@vds/typography';
import { ListGroup, ListGroupItem, ListGroupItemTitle } from '@vds/lists';
import { Cell, Table } from '@vds/tables';

const NewCompareCartModal = (props) => {

    const { lqState, appState, buildProductState, cartRedState, cartProfileState, modalWindowState, checkoutState, visitId, dispatch, saveState, linkEditTagCall, flowType, showMovesOldCart, moveExpState } = props;
    const isMobile = (window.screen.width < 768) ? true : false; 
    const cartState = cartRedState; 
    const profileState = cartProfileState;
    const [profileActiveTabIndex, setprofileActiveTabIndex] = useState(profileState?.splitBillTab);
    const [activeTabIndex, setactiveTabIndex] = useState(cartState?.splitBillTab);
    const [ isClassicalFlow ] = useState(!buildProductState?.mnFromApi); 

    let isCartDataEmpty = cartState?.cartData !== null && cartState?.cartData?.length !== 0 ? true : false;
    let isProfileDataEmpty = profileState?.cartData !== null && profileState?.cartData?.length !== 0 ? true : false;
    let isAutopayinCart = false; 
    let currentPerksData = '';
    let perksData = '';
    let currentInternetEquipment = '';
    let internetEquipment = '';
    let profileInternetServiceHeader = '';
    let internetServiceHeader = '';
    let currentInternetPrice = 0;
    let internetPrice = 0;
    let currentInternetSecTotalPrice = 0;
    let internetSecTotalPrice = 0;
    let profileTvServiceHeader = '';
    let tvServiceHeader = '';
    let currentTvEquipment = '';
    let tvEquipment = '';
    let currentTvPrice = 0;
    let tvPrice = 0;
    let currentTvSecTotalPrice = 0;
    let tvSecTotalPrice = 0;
    let profileVoiceServiceHeader = '';
    let voiceServiceHeader = '';
    let currentVoiceEquipment = '';
    let voiceEquipment = '';
    let currentVoicePrice = 0;
    let voicePrice = 0;
    let currentVoiceSecTotalPrice = 0;
    let voiceSecTotalPrice = 0;
    let numText = 'New Phone Number';
    let displayTNProfile = `(${buildProductState?.requestTNProfile?.slice(0, 3)}) ${buildProductState?.requestTNProfile?.slice(
      3,
      6,
    )} -${buildProductState?.requestTNProfile?.slice(6, 10)}`;
    let displayTN = `(${buildProductState?.requestTN?.slice(0, 3)}) ${buildProductState?.requestTN?.slice(
      3,
      6,
    )} -${buildProductState?.requestTN?.slice(6, 10)}`;
    let profileSplitBillTab = profileActiveTabIndex;
    let splitBillTab = activeTabIndex;

    const isProfileStreamServiceSelected = profileState?.cartData[profileSplitBillTab]?.streamService?.streamServiceProds?.length > 0  
    const profileServiceHeaders = isProfileDataEmpty && profileState?.cartData[profileSplitBillTab]?.serviceHeaders!==null;
    const profileDataService = profileState?.cartOrderDetail?.servicesOrdered?.toLowerCase()?.includes('data');
    const profileVideoService = profileState?.cartOrderDetail?.servicesOrdered?.toLowerCase()?.includes('video') || isProfileStreamServiceSelected ;
    const profileVoiceService = profileState?.cartOrderDetail?.servicesOrdered?.toLowerCase()?.includes('fios_voice');

    const isStreamServiceSelected = cartState?.cartData[splitBillTab]?.streamService?.streamServiceProds?.length > 0  
    const serviceHeaders = isCartDataEmpty && cartState?.cartData[splitBillTab]?.serviceHeaders!==null;
    const dataService = cartState?.cartOrderDetail?.servicesOrdered?.toLowerCase()?.includes('data');
    const videoService = cartState?.cartOrderDetail?.servicesOrdered?.toLowerCase()?.includes('video') || isStreamServiceSelected ;
    const voiceService = cartState?.cartOrderDetail?.servicesOrdered?.toLowerCase()?.includes('fios_voice');
    
    let profileClassicalTitle = isProfileDataEmpty && profileState?.cartData[splitBillTab]?.serviceHeaders!==null ? cartState?.cartData[splitBillTab]?.serviceHeaders.title :'';
    let classicalTitle = isCartDataEmpty && cartState?.cartData[splitBillTab]?.serviceHeaders!==null ? cartState?.cartData[splitBillTab]?.serviceHeaders.title :'';
    let profileClassicalPrice = isProfileDataEmpty && profileState?.cartHeader[splitBillTab]?.serviceHeaders!==null ? cartState?.cartData[splitBillTab]?.serviceHeaders?.totalPrice:'';
    let classicalPrice = isCartDataEmpty && cartState?.cartHeader[splitBillTab]?.serviceHeaders!==null ? cartState?.cartData[splitBillTab]?.serviceHeaders?.totalPrice:'';

    let profileClassicDoublePlay = profileClassicalTitle?.toLowerCase()?.includes('verizon double play');
    let profileClassicTriplePlay = profileClassicalTitle?.toLowerCase()?.includes('verizon triple play');
    let classicDoublePlay = classicalTitle?.toLowerCase()?.includes('verizon double play');
    let classicTriplePlay = classicalTitle?.toLowerCase()?.includes('verizon triple play');

    if(profileClassicDoublePlay || profileClassicTriplePlay){
        profileClassicalPrice = isCartDataEmpty && cartState?.cartHeader[splitBillTab]?.monthlyRcPrice!==null ? cartState?.cartHeader[splitBillTab]?.monthlyRcPrice:'';
    }

    if(classicDoublePlay || classicTriplePlay){
      classicalPrice = isCartDataEmpty && cartState?.cartHeader[splitBillTab]?.monthlyRcPrice!==null ? cartState?.cartHeader[splitBillTab]?.monthlyRcPrice:'';
    }

    const isInternetSelected = (buildProductState?.internet?.selectedProduct !== null);
    const isTVSelected = (buildProductState?.tv?.selectedProduct !== null);
    const isVoiceSelected = (buildProductState?.voice?.selectedProduct !== null);

    let setupcharge = cartState?.isFiosSetupFee;
    let isSetupFeeWaived = false;
    let qualifiedSpeedProducts = buildProductState?.internet?.m2mPlans;
    let maxSpeedCode = buildProductAction.getMaxQualifiedSpeedProduct(qualifiedSpeedProducts);
  
    {/** Classic Address year agreement */}
    let currentYearAgreement = '';
    let yearAgreement = '';

    if (isClassicalFlow &&
        isProfileDataEmpty &&
        profileState?.cartData[splitBillTab]?.serviceHeaders !== undefined &&
        profileState?.cartData[splitBillTab]?.serviceHeaders?.servicehead !== undefined &&
        profileState?.cartData[splitBillTab]?.serviceHeaders?.servicehead !== null &&
        profileState?.cartData[splitBillTab]?.serviceHeaders?.servicehead?.length > 0
    ) {
        currentYearAgreement = profileState?.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((head, index) => {
            if (head.prodName.indexOf('year') > -1) {    
                return <>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                        {head.prodName}
                    </Cell>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331' }}>
                    </Cell>
                </>
            }
        return '';
        });
    }  

    if (isClassicalFlow &&
        isCartDataEmpty &&
        cartState?.cartData[splitBillTab]?.serviceHeaders !== undefined &&
        cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead !== undefined &&
        cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead !== null &&
        cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead?.length > 0
    ) {
        yearAgreement = cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((head, index) => {
            if (head.prodName.indexOf('year') > -1) {    
                return <>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                        {head.prodName}
                    </Cell>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331' }}>
                    </Cell>
                </>
            }
        return '';
        });
    }  
  
    const product = buildProductState?.internet?.selectedProduct;
    const list = [...(product?.specialOffers || []), ...(product?.discountOffers || [])];
    let fiosPresent = list.find(item => item.OfferText.toLowerCase().includes('fios setup discount'));
    const nonGigSelectedProduct = (product?.speedCode === '939' || product?.speedCode === '940');
    let installationType = false;
    let professionalOneTimeCharge = false;
    let showFiosDerterminedAtCheckout = nonGigSelectedProduct;
    
    if ( nonGigSelectedProduct ) {
        if ( checkoutState?.accordionStatus?.creditCheck!=="completed" ) {
            showFiosDerterminedAtCheckout = true; 
            fiosPresent = false;
            installationType = false;
        } else if ( checkoutState?.accordionStatus?.creditCheck==="completed" ) {
            showFiosDerterminedAtCheckout= false;
            installationType = true;
     
            if ( checkoutState?.selDueDateType !== '' && checkoutState?.eligibleInstallation==="TechOnly" && checkoutState?.selDueDateType==="TECHVISIT" ) {
                professionalOneTimeCharge = true;
                installationType = true;
            }
        }
    } else {
        professionalOneTimeCharge = false;
        installationType = true;
    }
 
    const getInternetServiceHeader = () => {
        let currentTitle = '';
        let title = '';
    
        profileInternetServiceHeader = profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
            if ( isProfileDataEmpty &&    
                serviceheaditems.prodType === 'FTTPD'
            ) {
                currentTitle = ReactHtmlParser(serviceheaditems.prodName.substring(serviceheaditems.prodName.indexOf(':') + 1));
                currentInternetPrice = serviceheaditems.price !== '$0.00' || (serviceheaditems.prodType === 'FTTPD' && serviceheaditems.price !== '$0.00') ? serviceheaditems.price + '/mo' : '';
                currentInternetSecTotalPrice = currentInternetSecTotalPrice + (parseFloat(serviceheaditems?.price?.replace("$","")) || 0);
                return true;
            }
        });
    
        internetServiceHeader = cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
            if ( isCartDataEmpty &&    
                serviceheaditems.prodType === 'FTTPD'
            ) {
                title = ReactHtmlParser(serviceheaditems.prodName.substring(serviceheaditems.prodName.indexOf(':') + 1));
                internetPrice = serviceheaditems.price !== '$0.00' || (serviceheaditems.prodType === 'FTTPD' && serviceheaditems.price !== '$0.00') ? serviceheaditems.price + '/mo' : '';
                internetSecTotalPrice= internetSecTotalPrice + (parseFloat(serviceheaditems?.price?.replace("$","")) || 0);
                return true;
            }
        });

        return ( <>
        <div className="margin-bottom-zero">
            <div style={{display:'inline-flex', width:'100%'}}>
                <Table>
                    {(isClassicalFlow && (profileClassicDoublePlay || profileClassicTriplePlay ||classicDoublePlay || classicTriplePlay)) && 
                    <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            {profileClassicalTitle}
                        </Cell>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            <div className="right">
                                {profileClassicalPrice}
                            </div>
                        </Cell>
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            {classicalTitle}
                        </Cell>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            <div className="right">
                                {classicalPrice}
                            </div>
                        </Cell>
                    </Cell>
                </Table>}
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            {currentTitle}
                        </Cell>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            <div className="right">
                                {currentInternetPrice}
                            </div>
                        </Cell>
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            {title}
                        </Cell>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            <div className="right">
                                {internetPrice}
                            </div>
                        </Cell>
                    </Cell>
                </Table>
                </Table>
            </div>
        </div>
        </> );
    }
  
    const getInternetSubList = () => {
        let currentInternetEquipmentArray = [];
        let internetEquipmentArray = [];

        {/**Equipments Data */}

        currentInternetEquipmentArray = profileState?.cartData[profileSplitBillTab]?.equipments?.equipment?.filter(
            (equipmentitems) =>
                equipmentitems.prodType !== 'VROOM' && 
                equipmentitems.prodType !== 'DUMMYVROOM' &&
                equipmentitems.prodType !== 'CEDEVICEAPP' &&
                equipmentitems.prodType !== 'CEDEVICEAPPBNDL' &&
                equipmentitems.prodType !== 'VFEATURE' &&
                equipmentitems.prodType !== 'VCPEVMS' &&
                equipmentitems.prodType !== 'VCPEATV' &&
                equipmentitems.prodType !== 'VCPEIP'
        );

        internetEquipmentArray = cartState?.cartData[splitBillTab]?.equipments?.equipment?.filter(
            (equipmentitems) =>
                equipmentitems.prodType !== 'VROOM' && 
                equipmentitems.prodType !== 'DUMMYVROOM' &&
                equipmentitems.prodType !== 'CEDEVICEAPP' &&
                equipmentitems.prodType !== 'CEDEVICEAPPBNDL' &&
                equipmentitems.prodType !== 'VFEATURE' &&
                equipmentitems.prodType !== 'VCPEVMS' &&
                equipmentitems.prodType !== 'VCPEATV' &&
                equipmentitems.prodType !== 'VCPEIP'
        );
      
        currentInternetEquipment = currentInternetEquipmentArray?.map((equipmentitems, index) => {
            let dataPrice = "Included";
            if ( equipmentitems.price!=="Included" && 
                (equipmentitems.prodType === 'ROUTERBILLER' || 
                equipmentitems.prodType === "ACCESSPOINTBILLER") ) {
                    dataPrice = parseFloat(equipmentitems?.price?.replace("$","")) || 0;
                    currentInternetSecTotalPrice= currentInternetSecTotalPrice + (parseFloat(dataPrice) || 0 );
                    dataPrice = (equipmentitems?.price === "$0.0") ? "Included" : `${equipmentitems?.price}/mo`;
            }
            
            return <>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                        {equipmentitems.prodTypeVal === 'CUSTOMER_PROVIDED_ROUTER' &&
                        buildProductState !== undefined &&
                        buildProductState?.customRouterName !== undefined &&
                        buildProductState?.customRouterName !== ''
                        ? ReactHtmlParser(buildProductState?.customRouterName)
                        : InHomeUtils.isNotNull(equipmentitems.quantity) && equipmentitems.quantity > 1
                        ? ReactHtmlParser(equipmentitems.prodName) + '(' + equipmentitems.quantity + ' )'
                        : equipmentitems.prodId === 'Q7757'
                        ? (equipmentitems.prodName = 'Fios Extender')
                        : ReactHtmlParser(equipmentitems.prodName?.trim() === 'Rent: Verizon Router' ? 'Router only' : equipmentitems.prodName)}
                    </Cell>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (equipmentitems?.price?.toLowerCase() === 'included' || equipmentitems?.price === '$0.0') ? '#008331' : '#000000' }}>
                        <div className="right">
                            {dataPrice}
                        </div>
                    </Cell>
            </>
        });
      
        internetEquipment = internetEquipmentArray?.map((equipmentitems, index) => {
            let dataPrice = "Included";
            if ( equipmentitems.price!=="Included" && 
                (equipmentitems.prodType === 'ROUTERBILLER' || 
                equipmentitems.prodType === "ACCESSPOINTBILLER") ) {
                    dataPrice = parseFloat(equipmentitems?.price?.replace("$","")) || 0;
                    internetSecTotalPrice= internetSecTotalPrice + (parseFloat(dataPrice) || 0 );
                    dataPrice = (equipmentitems?.price === "$0.0") ? "Included" : `${equipmentitems?.price}/mo`;
            }
            
            return <>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                        {equipmentitems.prodTypeVal === 'CUSTOMER_PROVIDED_ROUTER' &&
                        buildProductState !== undefined &&
                        buildProductState?.customRouterName !== undefined &&
                        buildProductState?.customRouterName !== ''
                        ? ReactHtmlParser(buildProductState?.customRouterName)
                        : InHomeUtils.isNotNull(equipmentitems.quantity) && equipmentitems.quantity > 1
                        ? ReactHtmlParser(equipmentitems.prodName) + '(' + equipmentitems.quantity + ' )'
                        : equipmentitems.prodId === 'Q7757'
                        ? (equipmentitems.prodName = 'Fios Extender')
                        : ReactHtmlParser(equipmentitems.prodName?.trim() === 'Rent: Verizon Router' ? 'Router only' : equipmentitems.prodName)}
                    </Cell>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (equipmentitems?.price?.toLowerCase() === 'included' || equipmentitems?.price === '$0.0') ? '#008331' : '#000000' }}>
                        <div className="right">
                            {dataPrice}
                        </div>
                    </Cell>
            </>
        });
    
        {/* Rewards Offers section */}     
    
        let currentInternetRewardOffers = '';  
        let internetRewardOffers = '';

        let isnetflixPerkRewardOffer = false;
        
        if ( isProfileDataEmpty &&
            profileState?.cartData[profileSplitBillTab]?.rewardOffers !== undefined &&
            profileState?.cartData[profileSplitBillTab]?.rewardOffers?.rewardOffers !== undefined &&
            profileState?.cartData[profileSplitBillTab]?.rewardOffers?.rewardOffers !== null &&
            profileState?.cartData?.[profileSplitBillTab]?.rewardOffers?.rewardOffers?.length > 0
        ) {
            const saveTheSaleOffers = ['R3883','R3884','R3885'];
            currentInternetRewardOffers = profileState?.cartData?.[profileSplitBillTab]?.rewardOffers?.rewardOffers?.filter((rewardItems) => 
                rewardItems?.offerFor === 'DATA' && 
                rewardItems?.offerFor !== 'SPCLDISCOUNT' && 
                rewardItems?.offerAttrValue !== "MF4MRKF15" && 
                rewardItems?.offerAttrValue !== "MF4DISCF15")
                ?.map((reward, index) => { 
                    
                    if(reward.offerFor === 'DATA' && reward?.offerAttrValue === 'NETMAX_PERK_DISCOUNT') {
                        isnetflixPerkRewardOffer = true;
                    }
        
                    const starzRewardOffer = <span style={{color:'#6F7171',fontSize:"14px"}}>$10.99/mo after</span>
                    let promoTxt = reward?.promoText;
        
                    if(saveTheSaleOffers?.includes(reward?.promoId)) {
                        if(reward?.promoId ==="R3883") {
                            promoTxt = "$200 Verizon Gift Card";
                        }
                        if(reward?.promoId ==="R3884") {
                            promoTxt = "$100 Verizon Gift Card";
                        }
                        if(reward?.promoId ==="R3885") {
                            promoTxt = "$50 Verizon Gift Card";
                        }
                    }
         
                    if(reward?.promoId ==="R4049") {
                        promoTxt = reward?.promoText?.replace('Fios','Xbox');
                        if (promoTxt?.includes("Xbox Gaming Bundle")) {
                            promoTxt = "Xbox Headset + Controller";
                        }
                    }
                    if(reward?.promoId ==="R4140") {
                        promoTxt = reward?.promoText?.replace('Fios','Xbox');
                        if (promoTxt?.includes("Xbox Gaming Bundle")) {
                            promoTxt = "Xbox Bundle - Headset + Controller";
                        }
                    }
                    if(reward?.promoId ==="R4139") {
                        if (promoTxt?.includes("series") || promoTxt?.includes("Series") ) {
                            promoTxt = "Xbox Series S";
                        }
                    }
                    if(reward?.promoId ==="R4050" || reward?.promoId ==="R4141") {
                        if (promoTxt?.includes("$50 Xbox eGift Card")) {
                            promoTxt = "Xbox $50 Gift Card";
                        }
                    }

                    return <>
                    <Table padding='compact' style={{width:'100%'}}>
                        <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                {promoTxt}
                            </Cell>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>
                                <div className="right">
                                    {reward?.promoId ==="R4339" ? <span style={{color:'black'}}>$0/mo {starzRewardOffer} </span>: 'Included'}
                                </div>
                            </Cell>
                        </Cell>
                    </Table>
                    </>
                });
        }

        if ( isCartDataEmpty &&
            cartState?.cartData[splitBillTab]?.rewardOffers !== undefined &&
            cartState?.cartData[splitBillTab]?.rewardOffers?.rewardOffers !== undefined &&
            cartState?.cartData[splitBillTab]?.rewardOffers?.rewardOffers !== null &&
            cartState?.cartData?.[splitBillTab]?.rewardOffers?.rewardOffers?.length > 0
        ) {
            const saveTheSaleOffers = ['R3883','R3884','R3885'];
            internetRewardOffers = cartState?.cartData?.[splitBillTab]?.rewardOffers?.rewardOffers?.filter((rewardItems) => 
                rewardItems?.offerFor === 'DATA' && 
                rewardItems?.offerFor !== 'SPCLDISCOUNT' && 
                rewardItems?.offerAttrValue !== "MF4MRKF15" && 
                rewardItems?.offerAttrValue !== "MF4DISCF15")
                ?.map((reward, index) => { 
                    
                    if(reward.offerFor === 'DATA' && reward?.offerAttrValue === 'NETMAX_PERK_DISCOUNT') {
                        isnetflixPerkRewardOffer = true;
                    }
        
                    const starzRewardOffer = <span style={{color:'#6F7171',fontSize:"14px"}}>$10.99/mo after</span>
                    let promoTxt = reward?.promoText;
        
                    if(saveTheSaleOffers?.includes(reward?.promoId)) {
                        if(reward?.promoId ==="R3883") {
                            promoTxt = "$200 Verizon Gift Card";
                        }
                        if(reward?.promoId ==="R3884") {
                            promoTxt = "$100 Verizon Gift Card";
                        }
                        if(reward?.promoId ==="R3885") {
                            promoTxt = "$50 Verizon Gift Card";
                        }
                    }
         
                    if(reward?.promoId ==="R4049") {
                        promoTxt = reward?.promoText?.replace('Fios','Xbox');
                        if (promoTxt?.includes("Xbox Gaming Bundle")) {
                            promoTxt = "Xbox Headset + Controller";
                        }
                    }
                    if(reward?.promoId ==="R4140") {
                        promoTxt = reward?.promoText?.replace('Fios','Xbox');
                        if (promoTxt?.includes("Xbox Gaming Bundle")) {
                            promoTxt = "Xbox Bundle - Headset + Controller";
                        }
                    }
                    if(reward?.promoId ==="R4139") {
                        if (promoTxt?.includes("series") || promoTxt?.includes("Series") ) {
                            promoTxt = "Xbox Series S";
                        }
                    }
                    if(reward?.promoId ==="R4050" || reward?.promoId ==="R4141") {
                        if (promoTxt?.includes("$50 Xbox eGift Card")) {
                            promoTxt = "Xbox $50 Gift Card";
                        }
                    }

                    return <>
                    <Table padding='compact' style={{width:'100%'}}>
                        <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                {promoTxt}
                            </Cell>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>
                                <div className="right">
                                    {reward?.promoId ==="R4339" ? <span style={{color:'black'}}>$0/mo {starzRewardOffer} </span>: 'Included'}
                                </div>
                            </Cell>
                        </Cell>
                    </Table>
                    </>
                });
        }
    
        {/*Special gift offers */}
    
        let currentInternetSpecialOffer = ''; 
        let internetSpecialOffer = '';
        
        if ( isProfileDataEmpty &&
            profileState?.cartData[profileSplitBillTab]?.Promotions !== undefined &&
            profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions !== undefined &&
            profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions !== null &&
            profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions?.length > 0
        ) {
            currentInternetSpecialOffer = profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions.filter((promoItems) => 
                promoItems.offerFor === 'DATA' && 
                (promoItems?.offerAttrValue === 'NETMAX_PERK_MARKER' && 
                    promoItems?.promoId === 'R4262') && 
                promoItems.offerAttr !=='PRICING' && 
                promoItems.offerAttr !== 'JMPADD' && 
                promoItems.offerAttr !=='EQUIPMENT' && 
                promoItems?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_TRACKER' && 
                promoItems?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_MARKER' && 
                ((promoItems.offerAttr !== 'SPCLDISCOUNT' && !isClassicalFlow) || 
                (isClassicalFlow && promoItems.offerAttr === 'SPCLDISCOUNT' && 
                    !(promoItems.offerAttrValue.toLowerCase().indexOf('autopay') !== -1 || 
                    promoItems.offerAttrValue.toLowerCase().indexOf('auto pay') !== -1) && 
                    promoItems?.offerAttrValue?.toLowerCase?.()?.indexOf?.('decline') === -1 ) || 
                    (isClassicalFlow && promoItems?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_DISCOUNT')))
                    .map((promo, index) => {
                        
                        if (promo.offerAttrValue !== '$20_FCPDataNYDMA') {
                            if (promo.promoText !== null && promo.promoText !== undefined && promo.promoText.indexOf('Auto Pay') > -1) {
                                isAutopayinCart = true;
                            }
                            if(promo?.promoId === 'R4262') {
                                promo.promoText = "Netflix & Max (With Ads) for 12 months on us"
                                if(isnetflixPerkRewardOffer) {
                                    return null;
                                }
                            }

                            return <>
                            <Table padding='compact' style={{width:'100%'}}>
                                <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                        {promo.promoText.includes('$')
                                        ? promo.promoText
                                        : promo.price && promo.price !== '0.00'
                                        ? parseFloat(promo.price) === parseInt(promo.price)
                                        ? promo.promoText
                                        : promo.promoText
                                        : promo.promoText}
                                    </Cell>
                                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>
                                        <div className="right">
                                            Included
                                        </div>
                                    </Cell>
                                </Cell>
                            </Table>
                            </>
                        }
                  });
        }
        
        if ( isCartDataEmpty &&
            cartState?.cartData[splitBillTab]?.Promotions !== undefined &&
            cartState?.cartData[splitBillTab]?.Promotions?.promotions !== undefined &&
            cartState?.cartData[splitBillTab]?.Promotions?.promotions !== null &&
            cartState?.cartData[splitBillTab]?.Promotions?.promotions?.length > 0
        ) {
            internetSpecialOffer = cartState?.cartData[splitBillTab]?.Promotions?.promotions.filter((promoItems) => 
                promoItems.offerFor === 'DATA' && 
                (promoItems?.offerAttrValue === 'NETMAX_PERK_MARKER' && 
                    promoItems?.promoId === 'R4262') && 
                promoItems.offerAttr !=='PRICING' && 
                promoItems.offerAttr !== 'JMPADD' && 
                promoItems.offerAttr !=='EQUIPMENT' && 
                promoItems?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_TRACKER' && 
                promoItems?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_MARKER' && 
                ((promoItems.offerAttr !== 'SPCLDISCOUNT' && !isClassicalFlow) || 
                (isClassicalFlow && promoItems.offerAttr === 'SPCLDISCOUNT' && 
                    !(promoItems.offerAttrValue.toLowerCase().indexOf('autopay') !== -1 || 
                    promoItems.offerAttrValue.toLowerCase().indexOf('auto pay') !== -1) && 
                    promoItems?.offerAttrValue?.toLowerCase?.()?.indexOf?.('decline') === -1 ) || 
                    (isClassicalFlow && promoItems?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_DISCOUNT')))
                    .map((promo, index) => {
                        
                        if (promo.offerAttrValue !== '$20_FCPDataNYDMA') {
                            if (promo.promoText !== null && promo.promoText !== undefined && promo.promoText.indexOf('Auto Pay') > -1) {
                                isAutopayinCart = true;
                            }
                            if(promo?.promoId === 'R4262') {
                                promo.promoText = "Netflix & Max (With Ads) for 12 months on us"
                                if(isnetflixPerkRewardOffer) {
                                    return null;
                                }
                            }

                            return <>
                            <Table padding='compact' style={{width:'100%'}}>
                                <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                        {promo.promoText.includes('$')
                                        ? promo.promoText
                                        : promo.price && promo.price !== '0.00'
                                        ? parseFloat(promo.price) === parseInt(promo.price)
                                        ? promo.promoText
                                        : promo.promoText
                                        : promo.promoText}
                                    </Cell>
                                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>
                                        <div className="right">
                                            Included
                                        </div>
                                    </Cell>
                                </Cell>
                            </Table>
                            </>
                        }
                  });
        }

        {/*Perks Data */}
    
        if ( isProfileDataEmpty &&
            profileState?.cartData[profileSplitBillTab]?.perks !== undefined &&
            profileState?.cartData[profileSplitBillTab]?.perks !== null &&
            profileState?.cartData[profileSplitBillTab]?.perks?.perks !== undefined &&
            profileState?.cartData[profileSplitBillTab]?.perks?.perks !== null &&
            profileState?.cartData[profileSplitBillTab]?.perks?.perks?.length > 0
        ) {
            
            const perks = profileState?.cartData[profileSplitBillTab]?.perks?.perks;
            currentPerksData = perks.map((perk, index) => {
                let perkActPrice;
        
                if(perk?.keyword) {
                    const perkMrp = perk?.keyword?.split('MRP:')?.[1];
                    perkActPrice = perkMrp?.split('|')?.[0];
                } else {
                    perkActPrice = getPerkActualPrice(perk.prodId);
                }
        
                const perkSavings = perk?.price;
        
                currentInternetSecTotalPrice= currentInternetSecTotalPrice + (parseFloat(perkSavings) || 0 );

                return <>
                <Table padding='compact' style={{width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            {perk.prodName}
                        </Cell>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            <div className="right">
                                {perkSavings + '/mo'}
                            </div>
                        </Cell>
                    </Cell>
                </Table>
                </>
            });
        }  
    
        if ( isCartDataEmpty &&
            cartState?.cartData[splitBillTab]?.perks !== undefined &&
            cartState?.cartData[splitBillTab]?.perks !== null &&
            cartState?.cartData[splitBillTab]?.perks?.perks !== undefined &&
            cartState?.cartData[splitBillTab]?.perks?.perks !== null &&
            cartState?.cartData[splitBillTab]?.perks?.perks?.length > 0
        ) {
            
            const perks = cartState?.cartData[splitBillTab]?.perks?.perks;
            perksData = perks.map((perk, index) => {
                let perkActPrice;
        
                if(perk?.keyword) {
                    const perkMrp = perk?.keyword?.split('MRP:')?.[1];
                    perkActPrice = perkMrp?.split('|')?.[0];
                } else {
                    perkActPrice = getPerkActualPrice(perk.prodId);
                }
        
                const perkSavings = perk?.price;
        
                internetSecTotalPrice= internetSecTotalPrice + (parseFloat(perkSavings) || 0 );

                return <>
                <Table padding='compact' style={{width:'100%'}}>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            {perk.prodName}
                        </Cell>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            <div className="right">
                                {perkSavings + '/mo'}
                            </div>
                        </Cell>
                    </Cell>
                </Table>
                </>
            });
        }   
    
    return ( <>
    <div className={(currentInternetEquipment || internetEquipment)?.length ? 'cart-tabs' : 'hide'}>
        <ul className="savingLineItems">
            <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                    {currentInternetEquipment}
                </Cell>
                <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                    {internetEquipment}
                </Cell>
            </Table>
        </ul>
        {yearAgreement?.length > 0 ? 
        <ul className="savingLineItems">
            <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                    {currentYearAgreement}
                </Cell>
                <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                    {yearAgreement}
                </Cell>
            </Table>
        </ul> : '' }
    </div>
    <div className={(currentInternetSpecialOffer || internetSpecialOffer)?.length || (currentInternetRewardOffers || internetRewardOffers)?.length ? 'cart-tabs' : 'hide'}>
        <hr aria-hidden="true" className = {`hrLineMini ${isMobile ? 'tileSubTitleMini' : ''}`} />
        <Body size="large" bold="true" color="#000000" primitive="h3">
            Special gifts, on us
        </Body>
        <hr aria-hidden="true" className = {`hrLineMini ${isMobile ? 'tileSubTitleMini' : ''}`} />
        <ul className="savingLineItems">
            <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                    {currentInternetSpecialOffer}
                </Cell>
                <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                    {internetSpecialOffer}
                </Cell>
            </Table>
        </ul>
        <ul className="savingLineItems">
            <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                    {currentInternetRewardOffers}
                </Cell>
                <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                    {internetRewardOffers}
                </Cell>
            </Table>
        </ul>            
    </div>
        
    {(currentPerksData || perksData)?.length > 0 && <div className="cart-tabs">
        <hr aria-hidden="true" className = {`hrLineMini ${isMobile ? 'tileSubTitleMini' : ''}`} />
        <Body size="large" bold="true" color="#000000" primitive="h3">
            Perks
        </Body>
        <hr aria-hidden="true" className = {`hrLineMini ${isMobile ? 'tileSubTitleMini' : ''}`} />
        <ul className="savingLineItems">
            <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                    {currentPerksData}
                </Cell>
                <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                    {perksData}
                </Cell>
            </Table>
        </ul>
    </div>}
    </> );
    }
    
    const getTVServiceHeader = () => {
        let currentTvTitle = '';
        let tvTitle = '';
    
        if(isProfileStreamServiceSelected){
            profileTvServiceHeader = profileState?.cartData[profileSplitBillTab]?.streamService?.streamServiceProds.map((serviceheaditems, index) => {
                if ( isProfileDataEmpty &&
                    serviceheaditems.prodType === 'OTTBASIC'
                ) {
                    currentTvTitle = ReactHtmlParser(serviceheaditems.prodName);
                    currentTvPrice = serviceheaditems.price !== '$0.00' || (serviceheaditems.prodType === 'OTTBASIC' && serviceheaditems.price !== '$0.00') ? serviceheaditems.price + '/mo' : '';
                    currentTvSecTotalPrice = currentTvSecTotalPrice + (parseFloat(serviceheaditems?.price?.replace("$","")) || 0);
                    return true;
                }
            });  
        } else {
            profileTvServiceHeader = profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
                if ( isProfileDataEmpty &&
                    profileState?.cartData[profileSplitBillTab]?.serviceHeaders !== undefined &&
                    profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead !== undefined &&
                    profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead !== null &&
                    profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead?.length > 0 &&
                    serviceheaditems?.prodType !== 'FTTPD' &&
                    serviceheaditems?.prodType !== 'FVPRIMARY' &&
                    ( serviceheaditems?.prodType === 'BASIC' || serviceheaditems?.prodType === 'BASICDIFF')
                ) {
                    currentTvTitle = ReactHtmlParser(serviceheaditems.prodName);
                    currentTvPrice = serviceheaditems.price !== '$0.00' || ((serviceheaditems.prodType === 'BASIC'  || serviceheaditems.prodType === 'BASICDIFF') && serviceheaditems.price !== '$0.00') ? `$${parseFloat(serviceheaditems.price.replace('$','')).toFixed(2)}` + '/mo' : '';
                    currentTvSecTotalPrice = currentTvSecTotalPrice + (parseFloat(serviceheaditems?.price?.replace("$","")) || 0);
                    return true;  
                }
            }); 
        }
    
        if(isStreamServiceSelected){
            tvServiceHeader = cartState?.cartData[splitBillTab]?.streamService?.streamServiceProds.map((serviceheaditems, index) => {
                if ( isCartDataEmpty &&
                    serviceheaditems.prodType === 'OTTBASIC'
                ) {
                    tvTitle = ReactHtmlParser(serviceheaditems.prodName);
                    tvPrice = serviceheaditems.price !== '$0.00' || (serviceheaditems.prodType === 'OTTBASIC' && serviceheaditems.price !== '$0.00') ? serviceheaditems.price + '/mo' : '';
                    tvSecTotalPrice = tvSecTotalPrice + (parseFloat(serviceheaditems?.price?.replace("$","")) || 0);
                    return true;
                }
            });  
        } else {
            tvServiceHeader = cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
                if ( isCartDataEmpty &&
                    cartState?.cartData[splitBillTab]?.serviceHeaders !== undefined &&
                    cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead !== undefined &&
                    cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead !== null &&
                    cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead?.length > 0 &&
                    serviceheaditems?.prodType !== 'FTTPD' &&
                    serviceheaditems?.prodType !== 'FVPRIMARY' &&
                    ( serviceheaditems?.prodType === 'BASIC' || serviceheaditems?.prodType === 'BASICDIFF')
                ) {
                    tvTitle = ReactHtmlParser(serviceheaditems.prodName);
                    tvPrice = serviceheaditems.price !== '$0.00' || ((serviceheaditems.prodType === 'BASIC'  || serviceheaditems.prodType === 'BASICDIFF') && serviceheaditems.price !== '$0.00') ? serviceheaditems.price + '/mo' : '';
                    tvSecTotalPrice = tvSecTotalPrice + (parseFloat(serviceheaditems?.price?.replace("$","")) || 0);
                    return true;  
                }
            }); 
        }
        
        return ( <>
        <Table padding='compact' style={{width:'100%'}}>
            <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                    {currentTvTitle}
                </Cell>
                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                    <div className="right">
                        {currentTvPrice}
                    </div>
                </Cell>
            </Cell>
            <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                    {tvTitle}
                </Cell>
                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                    <div className="right">
                        {tvPrice}
                    </div>
                </Cell>
            </Cell>
        </Table>
        </> );
    }
  
    const getDisplayPrice =(price, isMonthly) => {
        let priceStr = "";
  
        if (typeof price === "number") {
            priceStr = price.toString();
        } else if (typeof price === "string") {
            priceStr = price.replace(/^(\$)/, "").replace(/\,/g, "").replace(/(\/mo)$/, "");
        }
  
        const numberFormat = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(priceStr);
  
        if (numberFormat !== "$NaN") {
            if (numberFormat === "$0.00") {
                return "";
            }
            return numberFormat + (isMonthly ? "/mo" : "");
        } else {
            return price;
        }
    }

    const getTVSubList = () => {
        let streamingDeviceSkip = false;
        const selectedTVProd = buildProductState?.tv?.selectedProduct?.id; 
        const tvProdArray = ['R3574', 'R3576', 'Q9854', 'R3572', 'R3577','R4301','R4303','R4299','R4304'];
        
        if(tvProdArray.includes(selectedTVProd)) {
            streamingDeviceSkip = true;
        }
        
        let currentTvEquipmentArray = [];
        let tvEquipmentArray = [];
        let currentDisplayCEAppsBundle = "";
        let displayCEAppsBundle = "";
        let currentDisplayFiosConnection = "";
        let displayFiosConnection = "";
    
        {/*Equipments Data */}
    
        currentTvEquipmentArray = profileState?.cartData?.[profileSplitBillTab]?.equipments?.equipment?.filter((equipmentitems) =>
            (equipmentitems?.prodType !== 'DUMMYVROOM' &&
                equipmentitems?.prodType !== 'CEDEVICEAPP' &&
                //equipmentitems?.prodType !== 'VROOM' &&
                (isClassicalFlow ? equipmentitems?.prodType === 'VROOM' : equipmentitems?.prodType !== 'VROOM') &&
                //equipmentitems?.prodType !== 'CEDEVICEAPPBNDL' &&
                (equipmentitems?.prodName || '')?.toLowerCase().trim() !== "i don't want to use a streaming device." && // Introduced due to PRODDEF-37256  
                // equipmentitems?.prodType !== 'VCPEVMS' &&
                // equipmentitems?.prodType !== 'VCPEATV' &&
                equipmentitems?.prodType !== 'ROUTERBILLER' && 
                equipmentitems?.prodType !== 'ACCESSPOINTBILLER' && 
                equipmentitems?.prodType !== 'NETWORKEXTENDERMRC') || 
                (((equipmentitems?.prodType ==='ROUTERBILLER'  || 
                    equipmentitems?.prodType ==='ACCESSPOINTBILLER') && 
                    (!isInternetSelected && isTVSelected))  && 
                    ((isClassicalFlow && !profileClassicDoublePlay) || 
                    (!isInternetSelected && isTVSelected)) || 
                    (isClassicalFlow && equipmentitems?.prodType === "VFEATURE"))
        );
    
        tvEquipmentArray = cartState?.cartData?.[splitBillTab]?.equipments?.equipment?.filter((equipmentitems) =>
            (equipmentitems?.prodType !== 'DUMMYVROOM' &&
                equipmentitems?.prodType !== 'CEDEVICEAPP' &&
                //equipmentitems?.prodType !== 'VROOM' &&
                (isClassicalFlow ? equipmentitems?.prodType === 'VROOM' : equipmentitems?.prodType !== 'VROOM') &&
                //equipmentitems?.prodType !== 'CEDEVICEAPPBNDL' &&
                (equipmentitems?.prodName || '')?.toLowerCase().trim() !== "i don't want to use a streaming device." && // Introduced due to PRODDEF-37256  
                // equipmentitems?.prodType !== 'VCPEVMS' &&
                // equipmentitems?.prodType !== 'VCPEATV' &&
                equipmentitems?.prodType !== 'ROUTERBILLER' && 
                equipmentitems?.prodType !== 'ACCESSPOINTBILLER' && 
                equipmentitems?.prodType !== 'NETWORKEXTENDERMRC') || 
                (((equipmentitems?.prodType ==='ROUTERBILLER'  || 
                    equipmentitems?.prodType ==='ACCESSPOINTBILLER') && 
                    (!isInternetSelected && isTVSelected))  && 
                    ((isClassicalFlow && !classicDoublePlay) || 
                    (!isInternetSelected && isTVSelected)) || 
                    (isClassicalFlow && equipmentitems?.prodType === "VFEATURE"))
        );
        
        {/* Fios TV connections */}
    
        let currentFiosTVConnectionArr = [];
        let fiosTVConnectionArr = [];

        if(buildProductState?.showConnectedApps) {
            
            currentFiosTVConnectionArr = profileState?.cartData?.[profileSplitBillTab]?.equipments?.equipment?.filter(equipItem => 
                ['VROOM', 'DUMMYVROOM', 'CEDEVICEAPP', 'CEDEVICEAPPBNDL'].includes(equipItem?.prodType));
                if(currentFiosTVConnectionArr && currentFiosTVConnectionArr?.length) {
                    let stbCount = 0;
                    let ceAppCount = 0;
                    let selectedstbProd = buildProductState?.tvConnections &&
                    buildProductState?.tvConnections?.selectedProduct && 
                    (buildProductState?.tvConnections?.selectedProduct?.prodId || 
                        buildProductState?.tvConnections?.selectedProduct?.id) && 
                        buildProductState?.tvConnections?.equipments && 
                        buildProductState?.tvConnections?.equipments?.filter(p => 
                            p && (p?.id === buildProductState?.tvConnections?.selectedProduct?.prodId || 
                                p?.id === buildProductState?.tvConnections?.selectedProduct?.id));
                    
                    let fiosTVConnectionProd = currentFiosTVConnectionArr?.filter(p => p?.prodType === 'VROOM');
                    let stbProd = currentFiosTVConnectionArr?.filter(p => p?.prodType === 'VROOM');
                    let stbProdbox = currentFiosTVConnectionArr?.filter(p => p?.prodType === 'DUMMYVROOM');
                    let ceAppsParityProd = currentFiosTVConnectionArr?.filter(p => p?.prodType === 'CEDEVICEAPP');
                    let ceAppsBundleProd = buildProductState?.ceApps?.selectedProduct && currentFiosTVConnectionArr?.filter(p => 
                        p?.prodType === 'CEDEVICEAPPBNDL' && p?.prodTypeVal !== 'DUMMY');
                    let ceAppsBundleDeclinedProd = currentFiosTVConnectionArr?.filter(p => 
                        p?.prodType === 'CEDEVICEAPPBNDL' && p?.prodTypeVal === 'DUMMY');
                    let isCEBundleProdinCart = currentFiosTVConnectionArr.some(p => 
                        p?.prodType === 'CEDEVICEAPPBNDL');
        
                    ceAppsBundleDeclinedProd = ceAppsBundleDeclinedProd && ceAppsBundleDeclinedProd?.length ? ceAppsBundleDeclinedProd?.[0] : null;
                    fiosTVConnectionProd = fiosTVConnectionProd && fiosTVConnectionProd?.length ? fiosTVConnectionProd?.[0] : null;
                    stbProd = stbProd && stbProd?.length ? stbProd?.[0] : null;
                    ceAppsParityProd = ceAppsParityProd && ceAppsParityProd?.length ? ceAppsParityProd?.[0] : null;
                    ceAppsBundleProd = ceAppsBundleProd && ceAppsBundleProd?.length ? ceAppsBundleProd?.[0] : null;
          
                    let settopboxCount = 0;
          
                    if(stbProd) {
                        stbCount = selectedstbProd && selectedstbProd?.length && selectedstbProd?.[0]?.unitCount ? parseInt(selectedstbProd?.[0]?.unitCount) : 0;
                    }
                    if(stbProdbox) {
                        settopboxCount = InHomeUtils.isNotNull(stbProdbox) && InHomeUtils.isNotNull(stbProdbox[0]) && stbProdbox[0].unitCount ? parseInt(stbProdbox[0].unitCount) : 0;
                        if(stbCount==0){
                            stbCount = settopboxCount;
                        }
                    }
                    if(ceAppsParityProd) {
                        ceAppCount = buildProductState?.ceApps && buildProductState?.ceApps?.selectedProduct && buildProductState?.ceApps?.selectedProduct?.quantity ? parseInt(buildProductState?.ceApps?.selectedProduct?.quantity) : 0;
                    }
                    if(fiosTVConnectionProd) {
                        let vroomCount = buildProductState?.vRoom && buildProductState?.vRoom?.selectedProduct && buildProductState?.vRoom?.selectedProduct.unitCount ? parseInt(buildProductState?.vRoom?.selectedProduct?.unitCount) : 0;
                        let tvCount = InHomeUtils.isNotNull(stbProd) && stbProd?.unitCount ?parseInt(stbProd?.unitCount) : 0;
              
                        if(vroomCount==0){
                            vroomCount=tvCount;
                        }
              
                        ceAppCount = vroomCount - stbCount;
                        currentDisplayFiosConnection = <>
                        <div id="currentDisplayFiosConnection">
                            <Table padding='compact' style={{width:'100%'}}>
                                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                        {vroomCount}{` Fios TV Connection${vroomCount > 1 ? 's' : ''}`}
                                        {(vroomCount === stbCount) || (stbCount && ceAppCount) 
                                        ? `${(vroomCount === stbCount) || (stbCount && ceAppCount) 
                                        ? ` ${stbCount && (stbCount > 1 || ceAppCount) 
                                        ? `${stbCount}` : ''} Set-Top Box${stbCount > 1 
                                        ? 'es' : ''}` : ''}${stbCount && ceAppCount 
                                        ? ',' : ''} ${ceAppCount 
                                        ? `${ceAppCount} Streaming Device${ceAppCount > 1 
                                        ? 's' : ''}` : '' }`: ""}
                                    </Cell>
                                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (fiosTVConnectionProd?.price?.toLowerCase() === 'included') ? '#008331' : '#000000'}}>
                                        <div className="right">
                                            {getDisplayPrice(fiosTVConnectionProd.price, true)}
                                        </div>
                                    </Cell>
                            </Table>
                        </div>
                        </>
                        
                        if(ceAppsBundleProd) {
                            currentDisplayCEAppsBundle = <>
                            <div id="displayCEAppsBundle">
                                <Table padding='compact' style={{width:'100%'}}>
                                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                            {ReactHtmlParser(ceAppsBundleProd.prodName)}
                                        </Cell>
                                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                            <div className = "right">
                                                {getDisplayPrice(ceAppsBundleProd.price, true)}
                                            </div>
                                        </Cell>
                                </Table>
                            </div>
                            </>
                        }
                    }
                }

            fiosTVConnectionArr = cartState?.cartData?.[splitBillTab]?.equipments?.equipment?.filter(equipItem => 
                ['VROOM', 'DUMMYVROOM', 'CEDEVICEAPP', 'CEDEVICEAPPBNDL'].includes(equipItem?.prodType));
                if(fiosTVConnectionArr && fiosTVConnectionArr?.length) {
                    let stbCount = 0;
                    let ceAppCount = 0;
                    let selectedstbProd = buildProductState?.tvConnections &&
                    buildProductState?.tvConnections?.selectedProduct && 
                    (buildProductState?.tvConnections?.selectedProduct?.prodId || 
                        buildProductState?.tvConnections?.selectedProduct?.id) && 
                        buildProductState?.tvConnections?.equipments && 
                        buildProductState?.tvConnections?.equipments?.filter(p => 
                            p && (p?.id === buildProductState?.tvConnections?.selectedProduct?.prodId || 
                                p?.id === buildProductState?.tvConnections?.selectedProduct?.id));
                    
                    let fiosTVConnectionProd = fiosTVConnectionArr?.filter(p => p?.prodType === 'VROOM');
                    let stbProd = fiosTVConnectionArr?.filter(p => p?.prodType === 'VROOM');
                    let stbProdbox = fiosTVConnectionArr?.filter(p => p?.prodType === 'DUMMYVROOM');
                    let ceAppsParityProd = fiosTVConnectionArr?.filter(p => p?.prodType === 'CEDEVICEAPP');
                    let ceAppsBundleProd = buildProductState?.ceApps?.selectedProduct && fiosTVConnectionArr?.filter(p => 
                        p?.prodType === 'CEDEVICEAPPBNDL' && p?.prodTypeVal !== 'DUMMY');
                    let ceAppsBundleDeclinedProd = fiosTVConnectionArr?.filter(p => 
                        p?.prodType === 'CEDEVICEAPPBNDL' && p?.prodTypeVal === 'DUMMY');
                    let isCEBundleProdinCart = fiosTVConnectionArr.some(p => 
                        p?.prodType === 'CEDEVICEAPPBNDL');
        
                    ceAppsBundleDeclinedProd = ceAppsBundleDeclinedProd && ceAppsBundleDeclinedProd?.length ? ceAppsBundleDeclinedProd?.[0] : null;
                    fiosTVConnectionProd = fiosTVConnectionProd && fiosTVConnectionProd?.length ? fiosTVConnectionProd?.[0] : null;
                    stbProd = stbProd && stbProd?.length ? stbProd?.[0] : null;
                    ceAppsParityProd = ceAppsParityProd && ceAppsParityProd?.length ? ceAppsParityProd?.[0] : null;
                    ceAppsBundleProd = ceAppsBundleProd && ceAppsBundleProd?.length ? ceAppsBundleProd?.[0] : null;
          
                    let settopboxCount = 0;
          
                    if(stbProd) {
                        stbCount = selectedstbProd && selectedstbProd?.length && selectedstbProd?.[0]?.unitCount ? parseInt(selectedstbProd?.[0]?.unitCount) : 0;
                    }
                    if(stbProdbox) {
                        settopboxCount = InHomeUtils.isNotNull(stbProdbox) && InHomeUtils.isNotNull(stbProdbox[0]) && stbProdbox[0].unitCount ? parseInt(stbProdbox[0].unitCount) : 0;
                        if(stbCount==0){
                            stbCount = settopboxCount;
                        }
                    }
                    if(ceAppsParityProd) {
                        ceAppCount = buildProductState?.ceApps && buildProductState?.ceApps?.selectedProduct && buildProductState?.ceApps?.selectedProduct?.quantity ? parseInt(buildProductState?.ceApps?.selectedProduct?.quantity) : 0;
                    }
                    if(fiosTVConnectionProd) {
                        let vroomCount = buildProductState?.vRoom && buildProductState?.vRoom?.selectedProduct && buildProductState?.vRoom?.selectedProduct.unitCount ? parseInt(buildProductState?.vRoom?.selectedProduct?.unitCount) : 0;
                        let tvCount = InHomeUtils.isNotNull(stbProd) && stbProd?.unitCount ?parseInt(stbProd?.unitCount) : 0;
              
                        if(vroomCount==0){
                            vroomCount=tvCount;
                        }
              
                        ceAppCount = vroomCount - stbCount;
                        displayFiosConnection = <>
                        <div id="displayFiosConnection">
                            <Table padding='compact' style={{width:'100%'}}>
                                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                        {vroomCount}{` Fios TV Connection${vroomCount > 1 ? 's' : ''}`}
                                        {(vroomCount === stbCount) || (stbCount && ceAppCount) 
                                        ? `${(vroomCount === stbCount) || (stbCount && ceAppCount) 
                                        ? ` ${stbCount && (stbCount > 1 || ceAppCount) 
                                        ? `${stbCount}` : ''} Set-Top Box${stbCount > 1 
                                        ? 'es' : ''}` : ''}${stbCount && ceAppCount 
                                        ? ',' : ''} ${ceAppCount 
                                        ? `${ceAppCount} Streaming Device${ceAppCount > 1 
                                        ? 's' : ''}` : '' }`: ""}
                                    </Cell>
                                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (fiosTVConnectionProd?.price?.toLowerCase() === 'included') ? '#008331' : '#000000'}}>
                                        <div className="right">
                                            {getDisplayPrice(fiosTVConnectionProd.price, true)}
                                        </div>
                                    </Cell>
                            </Table>
                        </div>
                        </>
                        
                        if(ceAppsBundleProd) {
                            displayCEAppsBundle = <>
                            <div id="displayCEAppsBundle">
                                <Table padding='compact' style={{width:'100%'}}>
                                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                            {ReactHtmlParser(ceAppsBundleProd.prodName)}
                                        </Cell>
                                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                            <div className = "right">
                                                {getDisplayPrice(ceAppsBundleProd.price, true)}
                                            </div>
                                        </Cell>
                                </Table>
                            </div>
                            </>
                        }
                    }
                }
        }
    
        currentTvEquipment = currentTvEquipmentArray?.map((equipmentitems, index) => {
            const equipItemProdName = (equipmentitems?.prodName || '')?.toString().trim() === 'Rent: Verizon Router' ? 'Router Only' : (equipmentitems?.prodName || '');
            let prodName = ReactHtmlParser(equipItemProdName);
            // if(equipmentitems.prodType === 'VROOM'){
            //   prodName = ReactHtmlParser(equipmentitems.prodName + 'Set-TopBox');
            // }
            let streamingDeviceEquipment = '';

            if(equipmentitems.prodType === 'CEDEVICEAPPBNDL' && (streamingDeviceSkip)) {
                streamingDeviceEquipment = <div>
                    <Body size="small" color='#6F7171'>
                        {`$${(parseInt(equipmentitems?.bundleActucalPrice))}/mo after 60 days`}
                    </Body>
                </div>
            }

            currentTvSecTotalPrice = currentTvSecTotalPrice + (parseFloat(equipmentitems?.price?.replace("$","")) || 0)
      
            let monthTxt = '/mo';
      
            if(equipmentitems?.prodType ==='ROUTERNRCBILLER' &&  equipmentitems?.prodTypeVal === 'FTTP_ROUTER_CHR_WIRELESS_CONSUMER' ) {
                return
            }

            return <>
            <Table padding='compact' style={{width:'100%'}}> 
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                        {equipmentitems.prodTypeVal === 'CUSTOMER_PROVIDED_ROUTER' &&
                        buildProductState !== undefined &&
                        buildProductState?.customRouterName !== undefined &&
                        buildProductState?.customRouterName !== ''
                        ? ReactHtmlParser(buildProductState?.customRouterName)
                        : InHomeUtils.isNotNull(equipmentitems.quantity) && equipmentitems.quantity > 1
                        ? ReactHtmlParser(prodName) + '(' + equipmentitems.quantity + ' )'
                        : equipmentitems.prodId === 'Q7757'
                        ? (prodName = 'Fios Extender')
                        : ReactHtmlParser(prodName)}
                    </Cell>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (equipmentitems?.price?.toLowerCase() === 'included' || equipmentitems?.price === '$0.0') ? '#008331' : '#000000'}}>
                        <div className = "right">
                            {(equipmentitems?.price?.toLowerCase() === 'included' || equipmentitems?.price === '$0.0') 
                            ? 'Included' : equipmentitems?.price + monthTxt }
                            {streamingDeviceEquipment}
                        </div>
                    </Cell>
            </Table>
            </>
        });

        tvEquipment = tvEquipmentArray?.map((equipmentitems, index) => {
            const equipItemProdName = (equipmentitems?.prodName || '')?.toString().trim() === 'Rent: Verizon Router' ? 'Router Only' : (equipmentitems?.prodName || '');
            let prodName = ReactHtmlParser(equipItemProdName);
            // if(equipmentitems.prodType === 'VROOM'){
            //   prodName = ReactHtmlParser(equipmentitems.prodName + 'Set-TopBox');
            // }
            let streamingDeviceEquipment = '';

            if(equipmentitems.prodType === 'CEDEVICEAPPBNDL' && (streamingDeviceSkip)) {
                streamingDeviceEquipment = <div>
                    <Body size="small" color='#6F7171'>
                        {`$${(parseInt(equipmentitems?.bundleActucalPrice))}/mo after 60 days`}
                    </Body>
                </div>
            }

            tvSecTotalPrice = tvSecTotalPrice + (parseFloat(equipmentitems?.price?.replace("$","")) || 0)
      
            let monthTxt = '/mo';
      
            if(equipmentitems?.prodType ==='ROUTERNRCBILLER' &&  equipmentitems?.prodTypeVal === 'FTTP_ROUTER_CHR_WIRELESS_CONSUMER' ) {
                return
            }

            return <>
            <Table padding='compact' style={{width:'100%'}}> 
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                        {equipmentitems.prodTypeVal === 'CUSTOMER_PROVIDED_ROUTER' &&
                        buildProductState !== undefined &&
                        buildProductState?.customRouterName !== undefined &&
                        buildProductState?.customRouterName !== ''
                        ? ReactHtmlParser(buildProductState?.customRouterName)
                        : InHomeUtils.isNotNull(equipmentitems.quantity) && equipmentitems.quantity > 1
                        ? ReactHtmlParser(prodName) + '(' + equipmentitems.quantity + ' )'
                        : equipmentitems.prodId === 'Q7757'
                        ? (prodName = 'Fios Extender')
                        : ReactHtmlParser(prodName)}
                    </Cell>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (equipmentitems?.price?.toLowerCase() === 'included' || equipmentitems?.price === '$0.0') ? '#008331' : '#000000'}}>
                        <div className = "right">
                            {(equipmentitems?.price?.toLowerCase() === 'included' || equipmentitems?.price === '$0.0') 
                            ? 'Included' : equipmentitems?.price + monthTxt }
                            {streamingDeviceEquipment}
                        </div>
                    </Cell>
            </Table>
            </>
        });
    
        {/* Rewards Offers section */}     
    
        let currentTvRewardOffers = '';
        let tvRewardOffers = '';
    
        if ( isProfileDataEmpty &&
            profileState?.cartData[profileSplitBillTab]?.rewardOffers !== undefined &&
            profileState?.cartData[profileSplitBillTab]?.rewardOffers?.rewardOffers !== undefined &&
            profileState?.cartData[profileSplitBillTab]?.rewardOffers?.rewardOffers !== null &&
            profileState?.cartData?.[profileSplitBillTab]?.rewardOffers?.rewardOffers?.length > 0
        ) {
            currentTvRewardOffers = profileState?.cartData[profileSplitBillTab]?.rewardOffers?.rewardOffers.filter((rewardItems) => 
                rewardItems.offerFor === 'VIDEO' && rewardItems.offerAttr === 'VZREWARD').map((reward, index) => {
                    if (reward.offerAttrValue !== '$20_FCPDataNYDMA') {
                        return <>
                        <Table padding='compact' style={{width:'100%'}}> 
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                    {reward.promoText}
                                </Cell>
                                <Cell style={{padding: 0, paddingRight: '1rem', width:'50%', color: '#008331'}}> 
                                    <div className = "right">
                                        Included
                                    </div>
                                </Cell>
                        </Table>
                        </>
                    }
                });
            }
    
        if ( isCartDataEmpty &&
            cartState?.cartData[splitBillTab]?.rewardOffers !== undefined &&
            cartState?.cartData[splitBillTab]?.rewardOffers?.rewardOffers !== undefined &&
            cartState?.cartData[splitBillTab]?.rewardOffers?.rewardOffers !== null &&
            cartState?.cartData?.[splitBillTab]?.rewardOffers?.rewardOffers?.length > 0
        ) {
            tvRewardOffers = cartState?.cartData[splitBillTab]?.rewardOffers?.rewardOffers.filter((rewardItems) => 
                rewardItems.offerFor === 'VIDEO' && rewardItems.offerAttr === 'VZREWARD').map((reward, index) => {
                    if (reward.offerAttrValue !== '$20_FCPDataNYDMA') {
                        return <>
                        <Table padding='compact' style={{width:'100%'}}>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                    {reward.promoText}
                                </Cell>
                                <Cell style={{padding: 0, paddingRight: '1rem', width:'50%', color: '#008331'}}> 
                                    <div className = "right">
                                        Included
                                    </div>
                                </Cell>
                        </Table>
                        </>
                    }
                });
            }
    
            {/* Special gift offers */}
    
            let currentTvSpecialOffer = '';
            let tvSpecialOffer = '';
    
            if ( isProfileDataEmpty &&
                profileState?.cartData[profileSplitBillTab]?.Promotions !== undefined &&
                profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions !== undefined &&
                profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions !== null &&
                profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions?.length > 0 
            ) {        
                currentTvSpecialOffer = profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions.filter((promoItems) => 
                    promoItems.offerFor === 'VIDEO' && 
                promoItems.offerAttr !=='EQUIPMENT' && 
                ((promoItems.offerAttr !== 'SPCLDISCOUNT' && !isClassicalFlow) || 
                (isClassicalFlow && promoItems.offerAttr === 'SPCLDISCOUNT' && 
                    !(promoItems.offerAttrValue.toLowerCase().indexOf('autopay') !== -1 || 
                    promoItems.offerAttrValue.toLowerCase().indexOf('auto pay') !== -1) && 
                    promoItems?.offerAttrValue?.toLowerCase?.()?.indexOf?.('decline') === -1))).map((promo, index) => {
                    
                    // if((promo.offerAttr === 'SPCLDISCOUNT' && !isClassicalFlow) || (isClassicalFlow && promo.offerAttr === 'SPCLDISCOUNT' && (promo.offerAttrValue.toLowerCase().indexOf('autopay') > -1 || promo.offerAttrValue.toLowerCase().indexOf('auto pay') > -1))){
                    //   return false;
                    // }
        
                    if (promo.promoText !== null && promo.promoText !== undefined && promo.promoText.indexOf('Auto Pay') > -1) {
                        isAutopayinCart = true;
                    }

                    return <>
                    <Table padding='compact' style={{width:'100%'}}>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>  
                                {promo.promoText.includes('$')
                                ? promo.promoText
                                : promo.price && promo.price !== '0.00'
                                ? parseFloat(promo.price) === parseInt(promo.price)
                                ? promo.promoText
                                : promo.promoText
                                : promo.promoText}
                            </Cell>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>
                                <div className = "right">
                                    Included
                                </div>
                            </Cell>
                    </Table>
                    </>  
                    });
            }  
    
            if ( isCartDataEmpty &&
                cartState?.cartData[splitBillTab]?.Promotions !== undefined &&
                cartState?.cartData[splitBillTab]?.Promotions?.promotions !== undefined &&
                cartState?.cartData[splitBillTab]?.Promotions?.promotions !== null &&
                cartState?.cartData[splitBillTab]?.Promotions?.promotions?.length > 0 
            ) {        
                tvSpecialOffer = cartState?.cartData[splitBillTab]?.Promotions?.promotions.filter((promoItems) => 
                    promoItems.offerFor === 'VIDEO' && 
                promoItems.offerAttr !=='EQUIPMENT' && 
                ((promoItems.offerAttr !== 'SPCLDISCOUNT' && !isClassicalFlow) || 
                (isClassicalFlow && promoItems.offerAttr === 'SPCLDISCOUNT' && 
                    !(promoItems.offerAttrValue.toLowerCase().indexOf('autopay') !== -1 || 
                    promoItems.offerAttrValue.toLowerCase().indexOf('auto pay') !== -1) && 
                    promoItems?.offerAttrValue?.toLowerCase?.()?.indexOf?.('decline') === -1))).map((promo, index) => {
                    
                    // if((promo.offerAttr === 'SPCLDISCOUNT' && !isClassicalFlow) || (isClassicalFlow && promo.offerAttr === 'SPCLDISCOUNT' && (promo.offerAttrValue.toLowerCase().indexOf('autopay') > -1 || promo.offerAttrValue.toLowerCase().indexOf('auto pay') > -1))){
                    //   return false;
                    // }
        
                    if (promo.promoText !== null && promo.promoText !== undefined && promo.promoText.indexOf('Auto Pay') > -1) {
                        isAutopayinCart = true;
                    }

                    return <>
                    <Table padding='compact' style={{width:'100%'}}>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>  
                                {promo.promoText.includes('$')
                                ? promo.promoText
                                : promo.price && promo.price !== '0.00'
                                ? parseFloat(promo.price) === parseInt(promo.price)
                                ? promo.promoText
                                : promo.promoText
                                : promo.promoText}
                            </Cell>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>
                                <div className = "right">
                                    Included
                                </div>
                            </Cell>
                    </Table>
                    </>  
                    });
            }  
      
            {/* fios five selected Channales */}
      
            let currentFiosFiveSelectedChannels='';
            let currentFiosFiveSelectedChannelsLayout='';
            let fiosFiveSelectedChannels='';
            let fiosFiveSelectedChannelsLayout='';
      
            if ( isProfileDataEmpty &&
                profileState?.cartData?.[profileSplitBillTab]?.serviceHeaders !== undefined &&
                profileState?.cartData?.[profileSplitBillTab]?.serviceHeaders?.servicehead !== undefined &&
                profileState?.cartData?.[profileSplitBillTab]?.serviceHeaders?.servicehead !== null &&
                profileState?.cartData?.[profileSplitBillTab]?.serviceHeaders?.servicehead?.length > 0 
            ) {
                let fiveChannels = profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
                    if ( serviceheaditems.prodName.indexOf('Your Fios TV') > -1 ||
                    serviceheaditems.prodTypeVal == 'Fios_Five' ||
                    serviceheaditems.prodId === 'Q7818') {
                        
                        /**changed the filter from id to prodTypeVal as encountered with grandfathered products with different id */
        
                        profileState?.cartData?.[profileSplitBillTab]?.currentFiosFiveSelectedChannels?.map((channels, index) => {
                            if(channels?.prodName?.toLowerCase().indexOf('additional pack') < 0) {
                                if (currentFiosFiveSelectedChannels) {
                                    currentFiosFiveSelectedChannels += `, ${ReactHtmlParser(channels?.prodName)}`;
                                } else {
                                    currentFiosFiveSelectedChannels = ReactHtmlParser(channels?.prodName);
                                }
                                return true;
                            }
                        });
                    }
                })
      
                if(currentFiosFiveSelectedChannels) {
                    currentFiosFiveSelectedChannelsLayout = <>
                    <Table padding='compact' style={{width:'100%'}}>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>  
                                {`Channels - ${ReactHtmlParser(currentFiosFiveSelectedChannels)} `}
                            </Cell>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>  
                                <div className = "right">
                                    Included
                                    </div>
                            </Cell>
                    </Table>
                    </>
                }
            }
      
            if ( isCartDataEmpty &&
                cartState?.cartData?.[splitBillTab]?.serviceHeaders !== undefined &&
                cartState?.cartData?.[splitBillTab]?.serviceHeaders?.servicehead !== undefined &&
                cartState?.cartData?.[splitBillTab]?.serviceHeaders?.servicehead !== null &&
                cartState?.cartData?.[splitBillTab]?.serviceHeaders?.servicehead?.length > 0 
            ) {
                let fiveChannels = cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
                    if ( serviceheaditems.prodName.indexOf('Your Fios TV') > -1 ||
                    serviceheaditems.prodTypeVal == 'Fios_Five' ||
                    serviceheaditems.prodId === 'Q7818') {
                        
                        /**changed the filter from id to prodTypeVal as encountered with grandfathered products with different id */
        
                        cartState?.cartData?.[splitBillTab]?.fiosFiveSelectedChannels?.map((channels, index) => {
                            if(channels?.prodName?.toLowerCase().indexOf('additional pack') < 0) {
                                if (fiosFiveSelectedChannels) {
                                    fiosFiveSelectedChannels += `, ${ReactHtmlParser(channels?.prodName)}`;
                                } else {
                                    fiosFiveSelectedChannels = ReactHtmlParser(channels?.prodName);
                                }
                                return true;
                            }
                        });
                    }
                })
      
                if(fiosFiveSelectedChannels) {
                    fiosFiveSelectedChannelsLayout = <>
                    <Table padding='compact' style={{width:'100%'}}>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>  
                                {`Channels - ${ReactHtmlParser(fiosFiveSelectedChannels)} `}
                            </Cell>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>  
                                <div className = "right">
                                    Included
                                    </div>
                            </Cell>
                    </Table>
                    </>
                }
            }
      
            {/* premium tv channels */}
      
            let currentPremiumChannels = '';
            let currentPremiumChannelsPrice = 0;
            let currentPremiumChannelsList = '';
            let premiumChannels = '';
            let premiumChannelsPrice = 0;
            let premiumChannelsList = '';
      
            if ( isProfileDataEmpty &&
                profileState?.cartData[profileSplitBillTab]?.channel !== undefined &&
                profileState?.cartData[profileSplitBillTab]?.channel !== null &&
                profileState?.cartData[profileSplitBillTab]?.channel?.channelsProds !== undefined &&
                profileState?.cartData[profileSplitBillTab]?.channel?.channelsProds !== null &&
                profileState?.cartData[profileSplitBillTab]?.channel?.channelsProds?.length > 0
            ) {
                currentPremiumChannelsPrice = (profileState?.cartData[profileSplitBillTab]?.channel?.channelsTotalprice || 0);
                profileState?.cartData[profileSplitBillTab]?.channel?.channelsProds.filter((promoItems) => 
                    promoItems.prodType !== "PREMIUMPACK").map((channels, index) => {
                        if (currentPremiumChannelsList) {
                            currentPremiumChannelsList = `${currentPremiumChannelsList}, ${ReactHtmlParser((channels?.prodName || '').trim())}`;
                        } else {
                            currentPremiumChannelsList = ReactHtmlParser((channels?.prodName || '').trim());
                        }
                        return true;
                    });
        
                    currentTvSecTotalPrice = currentPremiumChannelsPrice !== 0 ? currentTvSecTotalPrice + (parseFloat(currentPremiumChannelsPrice?.replace("$","")) || 0 ) : currentTvSecTotalPrice;
                    currentPremiumChannels = <>
                    <Table padding='compact' style={{width:'100%'}}>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}> 
                                {`Premium channel - ${ReactHtmlParser(currentPremiumChannelsList)}`}
                            </Cell>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                <div className = "right">
                                    {currentPremiumChannelsPrice + '/mo'}
                                </div>
                            </Cell>
                    </Table>
                    </>
            }
      
            if ( isCartDataEmpty &&
                cartState?.cartData[splitBillTab]?.channel !== undefined &&
                cartState?.cartData[splitBillTab]?.channel !== null &&
                cartState?.cartData[splitBillTab]?.channel?.channelsProds !== undefined &&
                cartState?.cartData[splitBillTab]?.channel?.channelsProds !== null &&
                cartState?.cartData[splitBillTab]?.channel?.channelsProds?.length > 0
            ) {
                premiumChannelsPrice = (cartState?.cartData[splitBillTab]?.channel?.channelsTotalprice || 0);
                cartState?.cartData[splitBillTab]?.channel?.channelsProds.filter((promoItems) => 
                    promoItems.prodType !== "PREMIUMPACK").map((channels, index) => {
                        if (premiumChannelsList) {
                            premiumChannelsList = `${premiumChannelsList}, ${ReactHtmlParser((channels?.prodName || '').trim())}`;
                        } else {
                            premiumChannelsList = ReactHtmlParser((channels?.prodName || '').trim());
                        }
                        return true;
                    });
        
                    tvSecTotalPrice = premiumChannelsPrice !== 0 ? tvSecTotalPrice + (parseFloat(premiumChannelsPrice?.replace("$","")) || 0 ) : tvSecTotalPrice;
                    premiumChannels = <>
                    <Table padding='compact' style={{width:'100%'}}>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}> 
                                {`Premium channel - ${ReactHtmlParser(premiumChannelsList)}`}
                            </Cell>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                <div className = "right">
                                    {premiumChannelsPrice + '/mo'}
                                </div>
                            </Cell>
                    </Table>
                    </>
            }
      
            let currentPremiumChannelsIncluded = '';       
            let currentPremiumChannelsListIncluded = '';
            let premiumChannelsIncluded = '';       
            let premiumChannelsListIncluded = '';
      
            if ( isProfileDataEmpty &&
                profileState?.cartData[profileSplitBillTab]?.serviceHeaders !== undefined &&
                profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead !== undefined &&
                profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead !== null &&
                profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead?.length > 0
            ) {       
                profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead.filter((promoItems) => 
                    promoItems.prodType === 'PREMIUM').map((channels, index) => {
                        if (currentPremiumChannelsListIncluded) {
                            currentPremiumChannelsListIncluded = `${currentPremiumChannelsListIncluded}, ${ReactHtmlParser((channels?.prodName || '').trim())}`;
                        } else {
                            currentPremiumChannelsListIncluded = ReactHtmlParser((channels?.prodName || '').trim());
                        }
                        return true;
                    });
          
                    if(currentPremiumChannelsListIncluded.length > 0) {
                        currentPremiumChannelsIncluded = <>
                        <Table padding='compact' style={{width:'100%'}}>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}> 
                                    {ReactHtmlParser(currentPremiumChannelsListIncluded)}
                                </Cell>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}> 
                                    <div className = "right">
                                        Included
                                    </div>
                                </Cell>
                        </Table>
                        </>
                    }
                }
      
            if ( isCartDataEmpty &&
                cartState?.cartData[splitBillTab]?.serviceHeaders !== undefined &&
                cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead !== undefined &&
                cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead !== null &&
                cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead?.length > 0
            ) {       
                cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead.filter((promoItems) => 
                    promoItems.prodType === 'PREMIUM').map((channels, index) => {
                        if (premiumChannelsListIncluded) {
                            premiumChannelsListIncluded = `${premiumChannelsListIncluded}, ${ReactHtmlParser((channels?.prodName || '').trim())}`;
                        } else {
                            premiumChannelsListIncluded = ReactHtmlParser((channels?.prodName || '').trim());
                        }
                        return true;
                    });
          
                    if(premiumChannelsListIncluded.length > 0) {
                        premiumChannelsIncluded = <>
                        <Table padding='compact' style={{width:'100%'}}>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}> 
                                    {ReactHtmlParser(premiumChannelsListIncluded)}
                                </Cell>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}> 
                                    <div className = "right">
                                        Included
                                    </div>
                                </Cell>
                        </Table>
                        </>
                    }
                }
       
                {/* international tv channels */}
      
                let currentIntrnlChannels = '';
                let currentIntrnlChannelsPrice = 0;
                let currentIntrnlChannelsList = '';
                let intrnlChannels = '';
                let intrnlChannelsPrice = 0;
                let intrnlChannelsList = '';

                if ( isProfileDataEmpty &&
                    profileState?.cartData[profileSplitBillTab]?.intrnlChannel !== undefined &&
                    profileState?.cartData[profileSplitBillTab]?.intrnlChannel !== null &&
                    profileState?.cartData[profileSplitBillTab]?.intrnlChannel?.intrnlChannelsProds !== undefined &&
                    profileState?.cartData[profileSplitBillTab]?.intrnlChannel?.intrnlChannelsProds !== null &&
                    profileState?.cartData[profileSplitBillTab]?.intrnlChannel?.intrnlChannelsProds?.length > 0
                ) {
                    currentIntrnlChannelsPrice = profileState?.cartData[profileSplitBillTab]?.intrnlChannel?.intrnlChannelsProds?.reduce((sum,item)=> sum + parseFloat(item.bundleActucalPrice),0);
                    profileState?.cartData[profileSplitBillTab]?.intrnlChannel?.intrnlChannelsProds.filter((promoItems) => 
                        promoItems.prodType !== "INTLPRMSPANISHTIER").map((channels, index) => {
                            if (currentIntrnlChannelsList) {
                                currentIntrnlChannelsList = `${currentIntrnlChannelsList}, ${ReactHtmlParser((channels?.prodName || '').trim())}`;
                            } else {
                                currentIntrnlChannelsList = ReactHtmlParser((channels?.prodName || '').trim());
                            }
                            return true;
                        });
        
                        currentTvSecTotalPrice = currentTvSecTotalPrice + (parseFloat(currentIntrnlChannelsPrice) || 0 )
                        currentIntrnlChannels = <>
                        <Table padding='compact' style={{width:'100%'}}>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                    {`International channel - ${ReactHtmlParser(currentIntrnlChannelsList)}`}
                                </Cell>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                    <div className = "right">
                                        {'$' + currentIntrnlChannelsPrice + '/mo'}
                                    </div>
                                </Cell>
                        </Table>
                        </>
                    }

                if ( isCartDataEmpty &&
                    cartState?.cartData[splitBillTab]?.intrnlChannel !== undefined &&
                    cartState?.cartData[splitBillTab]?.intrnlChannel !== null &&
                    cartState?.cartData[splitBillTab]?.intrnlChannel?.intrnlChannelsProds !== undefined &&
                    cartState?.cartData[splitBillTab]?.intrnlChannel?.intrnlChannelsProds !== null &&
                    cartState?.cartData[splitBillTab]?.intrnlChannel?.intrnlChannelsProds?.length > 0
                ) {
                    intrnlChannelsPrice = cartState?.cartData[splitBillTab]?.intrnlChannel?.intrnlChannelsProds?.reduce((sum,item)=> sum + parseFloat(item.bundleActucalPrice),0);
                    cartState?.cartData[splitBillTab]?.intrnlChannel?.intrnlChannelsProds.filter((promoItems) => 
                        promoItems.prodType !== "INTLPRMSPANISHTIER").map((channels, index) => {
                            if (intrnlChannelsList) {
                                intrnlChannelsList = `${intrnlChannelsList}, ${ReactHtmlParser((channels?.prodName || '').trim())}`;
                            } else {
                                intrnlChannelsList = ReactHtmlParser((channels?.prodName || '').trim());
                            }
                            return true;
                        });
        
                        tvSecTotalPrice = tvSecTotalPrice + (parseFloat(intrnlChannelsPrice) || 0 )
                        intrnlChannels = <>
                        <Table padding='compact' style={{width:'100%'}}> 
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                    {`International channel - ${ReactHtmlParser(intrnlChannelsList)}`}
                                </Cell>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                    <div className = "right">
                                        {'$' + intrnlChannelsPrice + '/mo'}
                                    </div>
                                </Cell>
                        </Table>
                        </>
                    }

        return ( <>
        <div className = {(currentDisplayFiosConnection || displayFiosConnection) || (currentTvEquipment || tvEquipment)?.length || (currentFiosFiveSelectedChannelsLayout || fiosFiveSelectedChannelsLayout)?.length ||  (currentPremiumChannelsList || premiumChannelsList) || (currentIntrnlChannelsList || intrnlChannelsList) || (currentPremiumChannelsListIncluded || premiumChannelsListIncluded) ? 'cart-tabs' : 'hide'}>
            <div>
                <Table padding='compact' style={{width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        {currentDisplayFiosConnection}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}> 
                        {displayFiosConnection}
                    </Cell>
                </Table>
            </div> 
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        {currentTvEquipment}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}> 
                        {tvEquipment}
                    </Cell>
                </Table>
            </div>   
            <div>{yearAgreement?.length > 0 ? 
                <ul className="savingLineItems">
                    <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                        <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                            {currentYearAgreement}
                        </Cell>
                        <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                            {yearAgreement}
                        </Cell>
                    </Table>
                </ul> :''}
            </div>
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        {currentFiosFiveSelectedChannelsLayout}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}> 
                        {fiosFiveSelectedChannelsLayout}
                    </Cell>
                </Table>
            </div>
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        {currentPremiumChannels}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}> 
                        {premiumChannels}
                    </Cell>
                </Table>
            </div>
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        {currentPremiumChannelsIncluded}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}> 
                        {premiumChannelsIncluded}
                    </Cell>
                </Table>
            </div> 
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        {currentIntrnlChannels}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}> 
                        {intrnlChannels}
                    </Cell>
                </Table>
            </div>
        </div>

        <div style={{paddingTop:"16px"}} className={(currentTvSpecialOffer || tvSpecialOffer)?.length || (currentTvRewardOffers || tvRewardOffers).length ? 'cart-tabs' : 'hide'}>
            <hr aria-hidden="true" className = {`hrLineMini ${isMobile ? 'tileSubTitleMini' : ''}`} />
            <Body size="large" bold="true" color="#000000" primitive="h3">
                Special gifts, on us
            </Body>               
            <hr aria-hidden="true" className = {`hrLineMini ${isMobile ? 'tileSubTitleMini' : ''}`} />
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        {currentTvSpecialOffer}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}> 
                        {tvSpecialOffer}
                    </Cell>
                </Table>
            </div>
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}>
                        {currentTvRewardOffers}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}> 
                        {tvRewardOffers}
                    </Cell>
                </Table>
            </div>
        </div>
        </> );
    }

    const getVoiceServiceHeader = () => {
        let currentVoiceTitle = '';
        let voiceTitle = '';
    
        profileVoiceServiceHeader = profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
            if ( serviceheaditems.prodType === 'FVPRIMARY' ) {
                currentVoiceTitle = ReactHtmlParser(serviceheaditems.prodName);
                currentVoicePrice = serviceheaditems.price !== '$0.00' || (serviceheaditems.prodType === 'FTTPD' && serviceheaditems.price === '$0.00') ? serviceheaditems.price + '/mo' : '';
                currentVoiceSecTotalPrice = currentVoiceSecTotalPrice + ( parseFloat(serviceheaditems?.price?.replace("$","")) || 0)
                return true;
            }
        });
        
        voiceServiceHeader = cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
            if ( serviceheaditems.prodType === 'FVPRIMARY' ) {
                voiceTitle = ReactHtmlParser(serviceheaditems.prodName);
                voicePrice = serviceheaditems.price !== '$0.00' || (serviceheaditems.prodType === 'FTTPD' && serviceheaditems.price === '$0.00') ? serviceheaditems.price + '/mo' : '';
                voiceSecTotalPrice = voiceSecTotalPrice + ( parseFloat(serviceheaditems?.price?.replace("$","")) || 0)
                return true;
            }
        });

        return ( <>
        {' '}
        <Table padding='compact' style={{width:'100%'}}>
            <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}> 
                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                    {currentVoiceTitle}
                </Cell> 
                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                    <div className = "right">
                        {currentVoicePrice}
                    </div>
                </Cell>
            </Cell>
            <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}> 
                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                    {voiceTitle}
                </Cell> 
                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                    <div className = "right">
                        {voicePrice}
                    </div>
                </Cell>
            </Cell>
        </Table>
        </> );
    }

    const getVoiceSubList = () => {
    
        let currentDisplayNewNum = '';
        let displayNewNum = '';
        let currentInternationalCalling = '';
        let internationalCalling = '';

        {/* Equipments Data */}

        let moveState = moveExpState?.moveLandingExp;
        let requestTNProfile;
        let requestTN;
        if( moveState!=undefined && 
            moveState!=null && 
            moveState!="" && 
            moveState.tnText!=undefined && 
            moveState.tnText !=null && 
            moveState.tnText !="" ) {
            
            numText = moveState.tnText;
            requestTNProfile = moveState.tn;
            requestTN = moveState.tn;
            displayTNProfile = `(${requestTNProfile.slice(0, 3)}) ${requestTNProfile.slice(3, 6)} -${requestTNProfile.slice(6, 10)}`
            displayTN = `(${requestTN.slice(0, 3)}) ${requestTN.slice(3, 6)} -${requestTN.slice(6, 10)}`
        }   

        if (displayTNProfile?.length < 10 && profileState?.cartOrderDetail?.servicesOrdered?.indexOf("FIOS_VOICE") > -1) {
            const isVoicePresentProfile = profileState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead?.find(item => item?.prodType === "FVPRIMARY")
      
            if (isVoicePresentProfile && isVoicePresentProfile?.prodName?.length > 20 && isVoicePresentProfile?.prodName?.indexOf("(") > -1 && isVoicePresentProfile?.prodName?.indexOf(")") > -1) {
                const phoneNumberProfile = isVoicePresentProfile?.prodName?.slice(isVoicePresentProfile?.prodName?.indexOf("("))
      
                if (phoneNumberProfile && phoneNumberProfile?.length > 13) {
                    requestTNProfile = phoneNumberProfile;
                    displayTNProfile = `(${requestTNProfile?.slice(1, 4)}) ${requestTNProfile?.slice(5, 8)} -${requestTNProfile?.slice(9, 13)}`
                }
            }
        } 

        if (displayTN?.length < 10 && cartState?.cartOrderDetail?.servicesOrdered?.indexOf("FIOS_VOICE") > -1) {
            const isVoicePresent = cartState?.cartData[profileSplitBillTab]?.serviceHeaders?.servicehead?.find(item => item?.prodType === "FVPRIMARY")
      
            if (isVoicePresent && isVoicePresent?.prodName?.length > 20 && isVoicePresent?.prodName?.indexOf("(") > -1 && isVoicePresent?.prodName?.indexOf(")") > -1) {
                const phoneNumber = isVoicePresent?.prodName?.slice(isVoicePresent?.prodName?.indexOf("("))
      
                if (phoneNumber && phoneNumber?.length > 13) {
                    requestTN = phoneNumber;
                    displayTN = `(${requestTN?.slice(1, 4)}) ${requestTN?.slice(5, 8)} -${requestTN?.slice(9, 13)}`
                }
            }
        } 
     
        if (displayTNProfile !== '' && requestTNProfile) {
            currentDisplayNewNum = <>
            <div>
                <Table padding='compact' style={{width:'100%'}}> 
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                        {numText + ' : ' + displayTNProfile}
                    </Cell>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>
                        <div className = "right">
                            Included
                        </div>
                    </Cell>
                </Table>
            </div>
            </>
        }
     
        if (displayTN !== '' && requestTN) {
            displayNewNum = <>
            <div>
                <Table padding='compact' style={{width:'100%'}}>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                        {numText + ' : ' + displayTN}
                    </Cell>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>
                        <div className = "right">
                            Included
                        </div>
                    </Cell>
                </Table>
            </div>
            </>
        }

        if ( isProfileDataEmpty &&
            profileState?.cartData[profileSplitBillTab].listing !== undefined &&
            profileState?.cartData[profileSplitBillTab].listing !== null &&
            profileState?.cartData[profileSplitBillTab].listing.listingProds !== undefined &&
            profileState?.cartData[profileSplitBillTab].listing.listingProds !== null &&
            profileState?.cartData[profileSplitBillTab].listing.listingProds.length > 0
        ) {
            currentVoiceEquipment = profileState?.cartData[profileSplitBillTab].listing.listingProds.map((items, index) => {
                currentVoiceSecTotalPrice = currentVoiceSecTotalPrice + ( parseFloat(items?.price?.replace("$","")) || 0 )
          
                if(items.prodName?.toString()?.toLowerCase().includes('international calling') || 
                window.location.href.indexOf("ordersummary") !== -1) {    
                    return <>
                    <div>
                        <Table padding='compact' style={{width:'100%'}}>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                    {items.prodName}
                                </Cell>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (items.price?.toLowerCase() === 'included' || items.price === '$0.0') ? '#008331' : '#000000'}}>
                                    <div className = "right">
                                        {(items.price === 'Included' || items.price === '$0.0') ? 'Included' : items.price + '/mo'}
                                    </div>
                                </Cell>
                        </Table>
                    </div>
                    </>

                } else if (items.prodName?.toString()?.toLowerCase().includes('fios digital voice')) { 
                    return <>
                    <div>
                        <Table padding='compact' style={{width:'100%'}}>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                    {items.prodName}
                                </Cell>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (items.price?.toLowerCase() === 'included' || items.price === '$0.0') ? '#008331' : '#000000'}}>
                                    <div className = "right">
                                        {(items.price === 'Included' || items.price === '$0.0') ? 'Included' : items.price + '/mo'}
                                    </div>
                                </Cell>
                        </Table>
                    </div>
                    </>
                }
            return <>
            <Table padding='compact' style={{width:'100%'}}> 
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                        {items.prodName}
                    </Cell>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (items.price?.toLowerCase() === 'included' || items.price === '$0.0') ? '#008331' : '#000000'}}>
                        <div className = "right">
                            {(items.price === 'Included' || items.price === '$0.0') ? 'Included' : items.price + '/mo'}
                        </div>
                    </Cell>
            </Table>
            </>
        });
    }

        if ( isCartDataEmpty &&
            cartState?.cartData[splitBillTab].listing !== undefined &&
            cartState?.cartData[splitBillTab].listing !== null &&
            cartState?.cartData[splitBillTab].listing.listingProds !== undefined &&
            cartState?.cartData[splitBillTab].listing.listingProds !== null &&
            cartState?.cartData[splitBillTab].listing.listingProds.length > 0
        ) {
            voiceEquipment = cartState?.cartData[splitBillTab].listing.listingProds.map((items, index) => {
                voiceSecTotalPrice = voiceSecTotalPrice + ( parseFloat(items?.price?.replace("$","")) || 0 )
          
                if(items.prodName?.toString()?.toLowerCase().includes('international calling') || 
                window.location.href.indexOf("ordersummary") !== -1) {    
                    return <>
                    <div>
                        <Table padding='compact' style={{width:'100%'}}> 
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                    {items.prodName}
                                </Cell>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (items.price?.toLowerCase() === 'included' || items.price === '$0.0') ? '#008331' : '#000000'}}>
                                    <div className = "right">
                                        {(items.price === 'Included' || items.price === '$0.0') ? 'Included' : items.price + '/mo'}
                                    </div>
                                </Cell>
                        </Table>
                    </div>
                    </>

                } else if (items.prodName?.toString()?.toLowerCase().includes('fios digital voice')) { 
                    return <>
                    <div>
                        <Table padding='compact' style={{width:'100%'}}>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                    {items.prodName}
                                </Cell>
                                <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (items.price?.toLowerCase() === 'included' || items.price === '$0.0') ? '#008331' : '#000000'}}>
                                    <div className = "right">
                                        {(items.price === 'Included' || items.price === '$0.0') ? 'Included' : items.price + '/mo'}
                                    </div>
                                </Cell>
                        </Table>
                    </div>
                    </>
                }
            return <>
            <Table padding='compact' style={{width:'100%'}}>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                        {items.prodName}
                    </Cell>
                    <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: (items.price?.toLowerCase() === 'included' || items.price === '$0.0') ? '#008331' : '#000000'}}>
                        <div className = "right">
                            {(items.price === 'Included' || items.price === '$0.0') ? 'Included' : items.price + '/mo'}
                        </div>
                    </Cell>
            </Table>
            </>
        });
    }

    {/* Special gift offers */}
     
    let voiceSpecialOffer = '';
    let currentVoiceSpecialOffer = '';
    
    if ( isProfileDataEmpty &&
        profileState?.cartData[profileSplitBillTab]?.Promotions !== undefined &&
        profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions !== undefined &&
        profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions !== null &&
        profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions?.length > 0
    ) {
        currentVoiceSpecialOffer = profileState?.cartData[profileSplitBillTab]?.Promotions?.promotions.filter((promoItems) => 
            promoItems.offerFor === 'PHONE' || promoItems.offerFor === 'FIOS_VOICE').map((promo, index) => {
                return <>
                <Table padding='compact' style={{width:'100%'}}> 
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            {promo.promoText.includes('$')
                            ? promo.promoText
                            : promo.price && promo.price !== '0.00'
                            ? parseFloat(promo.price) === parseInt(promo.price)
                            ? promo.promoText
                            : promo.promoText
                            : promo.promoText}
                        </Cell>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>
                            <div className = "right">
                                Included
                            </div>
                        </Cell>
                </Table>
                </>
            });
        }
    
    if ( isCartDataEmpty &&
        cartState?.cartData[splitBillTab]?.Promotions !== undefined &&
        cartState?.cartData[splitBillTab]?.Promotions?.promotions !== undefined &&
        cartState?.cartData[splitBillTab]?.Promotions?.promotions !== null &&
        cartState?.cartData[splitBillTab]?.Promotions?.promotions?.length > 0
    ) {
        voiceSpecialOffer = cartState?.cartData[splitBillTab]?.Promotions?.promotions.filter((promoItems) => 
            promoItems.offerFor === 'PHONE' || promoItems.offerFor === 'FIOS_VOICE').map((promo, index) => {
                return <>
                <Table padding='compact' style={{width:'100%'}}> 
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                            {promo.promoText.includes('$')
                            ? promo.promoText
                            : promo.price && promo.price !== '0.00'
                            ? parseFloat(promo.price) === parseInt(promo.price)
                            ? promo.promoText
                            : promo.promoText
                            : promo.promoText}
                        </Cell>
                        <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px', color: '#008331'}}>
                            <div className = "right">
                                Included
                            </div>
                        </Cell>
                </Table>
                </>
            });
        } 
      
        {/* Inside wire Mantainance */}
      
        let monthlyCharge = '';
        let currentMonthlyCharge = '';
      
        if ( profileState?.cartData !== null && 
            profileState?.cartData?.length > 0 && 
            profileState?.cartData[profileSplitBillTab]?.internet !== null && 
            profileState?.cartData[profileSplitBillTab]?.internet?.internetProds !== undefined && 
            profileState?.cartData[profileSplitBillTab]?.internet?.internetProds !== null && 
            profileState?.cartData[profileSplitBillTab]?.internet?.internetProds?.length > 0 ) {
                currentMonthlyCharge = profileState?.cartData[profileSplitBillTab]?.internet?.internetProds.map((internet, index) => { 
                    return <>
                    <Table padding='compact' style={{width:'100%'}}>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                {internet.prodName}
                            </Cell>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                <div className = "right">
                                    {internet?.price === 'Included' ? internet?.price : internet?.price + '/mo'}
                                </div>
                            </Cell>
                    </Table>
                    </>
                });
        }
      
        if ( cartState?.cartData !== null && 
            cartState?.cartData?.length > 0 && 
            cartState?.cartData[splitBillTab]?.internet !== null && 
            cartState?.cartData[splitBillTab]?.internet?.internetProds !== undefined && 
            cartState?.cartData[splitBillTab]?.internet?.internetProds !== null && 
            cartState?.cartData[splitBillTab]?.internet?.internetProds?.length > 0 ) {
                monthlyCharge = cartState?.cartData[splitBillTab]?.internet?.internetProds.map((internet, index) => { 
                    return <>
                    <Table padding='compact' style={{width:'100%'}}>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                {internet.prodName}
                            </Cell>
                            <Cell style={{padding: 0, fontSize: isMobile ? '12px' : '16px'}}>
                                <div className = "right">
                                    {internet?.price === 'Included' ? internet?.price : internet?.price + '/mo'}
                                </div>
                            </Cell>
                    </Table>
                    </>
                });
        }

        return ( <>
        <div className={((currentVoiceEquipment || voiceEquipment)?.length || (voiceSpecialOffer || currentVoiceSpecialOffer)?.length || internationalCalling.length || (monthlyCharge || currentMonthlyCharge).length) ? 'cart-tabs' : 'hide'}>
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}> 
                        {currentDisplayNewNum}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                        {displayNewNum}
                    </Cell>
                </Table>
            </div>
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}> 
                        {currentInternationalCalling}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                        {internationalCalling}
                    </Cell>
                </Table>
            </div>
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}> 
                        {currentVoiceEquipment}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                        {voiceEquipment}
                    </Cell>
                </Table>
            </div>
            <div>
                <Table padding='compact' style={{marginBottom: 0, width:'100%'}}>
                    <Cell style={{padding: 0, paddingRight: '1rem', width:'50%'}}> 
                        {currentMonthlyCharge}
                    </Cell>
                    <Cell style={{padding: 0, paddingLeft: '1rem', width:'50%'}}>
                        {monthlyCharge}
                    </Cell>
                </Table>
            </div>
        </div>
        </> );
    }

    const onCartSplitBillClick = (action) => {
        cartActions.splitBillTab(action, dispatch);
        setprofileActiveTabIndex(action);
        setactiveTabIndex(action);
    }
  
    let tierData = '';
  
    const getClassicalHeader = () => {
        if ( cartState?.cartHeader !== undefined &&
            cartState?.cartHeader !== null &&
            cartState?.cartHeader?.length > 0
        ) {
            if(lqState?.isFCPflow || (lqState && lqState?.hoaFlowDetails && lqState?.hoaFlowDetails?.isHoaFlow)) {
                tierData="";
            } else {
                tierData = cartState?.cartHeader.map((cartHeader, index) => {
                    if(index===3){
                        return null;
                    }
                
                return <li  cartindex={index}
                className = {splitBillTab === index ? "stepperClassicNC activeClassicNC" : "stepperClassicNC inactiveClassicNC"}  
                aria-selected="false" 
                onClick={(e) => onCartSplitBillClick(index)} 
                key={index}>
                    <div tabIndex="0" role="tab" aria-selected={splitBillTab === index } onKeyDown={(e) => this.handleTabKeyDown(e, index)}>
                        <div id="Price" className="stepperPrice">
                            {cartHeader.totalPrice === "0" ? tierprice : cartHeader.totalPrice}
                        </div>
                        <span id="MonthDesc" className="normal-weight text-small currentPlanTxt" >
                            { cartHeader.title}
                        </span>
                    </div>
                </li>
                })
            }
        }
        return tierData;
    }

    const ContentServiceRenderComp = (props) => {

        let showMainContent= true;
    
        if(props?.classicFlowType && props?.id !== 'Internet') {
            showMainContent = false;
        }

        return ( <React.Fragment>
            <div className={props?.mainTitle && !props?.classicFlowType ? (isMobile ? 'bg-white-border-mobile top-border-radius-zero margin-top-zero' : 'bg-white-border medium-margin-top-zero margin-bottom-tiny padding-bottom-zero top-border-radius-zero') : 'paddingClassicNC '}> 
                { showMainContent && <div className={isMobile ? 'miniCartTitle' : 'align_middle miniCartTitle'}>
                    { props?.classicFlowType ? 
                    <div className="width_100" style={{display:'flex'}}>
                        <div style={{ width:'60%'}}>
                            <Title size="small" color="#000000">
                                {props?.mainTitle}
                            </Title>
                        </div>
                        <div style={{color:"#6E6B65", width:'40%', textAlign:'right'}}>
                            <Title size="small" primitive='h3' aria-hidden='true' >
                                {props?.price}
                            </Title>
                        </div>
                    </div>
                    : <ListGroup topLine={false} bottomLine={false} surface="light">
                        <ListGroupItem actionElement={props?.classicFlowType ? 'textlink' :"none"} 
                        textLink={{ text: props?.classicFlowType ? props?.price : '', }}>
                            <ListGroupItemTitle 
                                children = { <Title size="small" bold={true} color="#000000">
                                    {props?.mainTitle}
                                </Title>} 
                            />
                        </ListGroupItem>
                    </ListGroup>
                    }
                </div> }
                
                { <hr aria-hidden="true" className = {`hrLineMini ${isMobile ? 'tileSubTitleMini' : ''}`} />}
                <div className="tileSubContentMini">
                    <div className="width_100">
                        {props?.mainHeaderSection}
                    </div>
                    <div className="width_100">
                        {props?.listItems}   
                    </div>
                </div>
            </div>
        </React.Fragment> );
    }

    useEffect(() => {
        
        /**Modal template */
     
        let selectedServices = { isInternet: InHomeUtils.isNotNull(buildProductState?.internet?.selectedProduct)? true: false, 
            isTv:  false, 
            isVoice: false, 
            isYouTubeTV: InHomeUtils.isNotNull(buildProductState?.streamServ?.selectedProduct) ? true : false,
            isDataGig: false,
            isData75M: false,
            isDataNotGig: false,
            isData2G:false};
            
        if (InHomeUtils.isNotNull(buildProductState?.internet?.selectedProduct)) { 
            if(InHomeUtils.isNotEmpty(buildProductState?.internet?.selectedProduct?.downSpeed)) {
                let selectedInternetProd = buildProductState?.internet?.selectedProduct;
                if(selectedInternetProd.downSpeed === '1024M') {
                    selectedServices.isDataGig = true;
                }
                if (selectedInternetProd.downSpeed === '2048M') {
                    selectedServices.isData2G = true;
                }
                if (selectedInternetProd.downSpeed === '2056M') {
                    selectedServices.isData2G = true;
                }
                if(selectedInternetProd.downSpeed !== '1024M') {
                    if(selectedInternetProd.downSpeed === '75M')
                        selectedServices.isData75M = true;
                    else
                    selectedServices.isDataNotGig = true;
                }
            }
        }
      
        if (InHomeUtils.isNotNull(buildProductState?.tv?.selectedProduct)) {
            selectedServices.isTv = true;
        }
        if (InHomeUtils.isNotNull(buildProductState?.voice?.selectedProduct)) {
            selectedServices.isVoice = true;
        }
        if (InHomeUtils.isNotNull(buildProductState?.streamServ?.selectedProduct)) {
            selectedServices.isSlingTV = true;
        }    
        if(InHomeUtils.isNotNull(buildProductState?.internet?.selectedProduct) && 
        InHomeUtils.isNotNull(buildProductState?.internet?.selectedProduct?.name) && 
        buildProductState?.internet?.selectedProduct?.name.indexOf('500') > -1 && 
        maxSpeedCode === '940'){
            selectedServices.isDataMaxSpeed=true;
        }
    
        /*end of template */
  
    }, []);
  
    if ( isCartDataEmpty && 
        cartState?.cartData[splitBillTab]?.oneTimeCharge !== undefined &&
        cartState?.cartData[splitBillTab]?.oneTimeCharge?.onetimecharge !== undefined &&
        cartState?.cartData[splitBillTab]?.oneTimeCharge?.onetimecharge !== null &&
        cartState?.cartData[splitBillTab]?.oneTimeCharge?.onetimecharge?.length > 0
    ) {
        let setup = cartState?.cartData[splitBillTab].oneTimeCharge.onetimecharge.filter((p) => p.prodType === 'SETUP');
        
        if (setup !== null && setup.length > 0 && setup[0].price !== null) {
            if (setup[0].price === 'Fee Waived') {
                isSetupFeeWaived = true;
                if (setupcharge !== 'FeeWaived') {
                    //this.isFiosSetup('FeeWaived');
                }
            } else {
                if (setupcharge !== ''){
                    //this.isFiosSetup('');
                } 
            }
        }
    }
  
    const isMax500plan = buildProductState?.internet?.m2mPlans?.findIndex(item => ["R3582","R3583"].includes(item?.id))> -1 ? false : true;
    
    if(isCartDataEmpty) {
        cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
            if (serviceheaditems?.prodName?.includes("Gig") || 
            buildProductState?.internet?.isFeeWaivedForAll || 
            buildProductState?.internet?.isInstallFeeWaivedAllPrd || 
            (isMax500plan && serviceheaditems?.prodName?.includes('500'))
            ) {
                if(serviceheaditems?.prodName?.includes("Gig") || buildProductState?.internet?.isInstallFeeWaivedAllPrd) {
                    isSetupFeeWaived =true;
                }
                if(isMax500plan && serviceheaditems?.prodName?.includes('500')) {
                    if(checkoutState?.accordionStatus?.creditCheck!=="completed") {
                        isSetupFeeWaived = false;
                    } else if (checkoutState?.accordionStatus?.creditCheck==="completed" && 
                        checkoutState?.eligibleInstallation==="TechOnly" && 
                        checkoutState?.selDueDateType==="TECHVISIT") {
                            isSetupFeeWaived = false;
                    } else if (checkoutState?.accordionStatus?.creditCheck==="completed" && 
                        (checkoutState?.selDueDateType_new === "EONTSELFINSTALL" || 
                        checkoutState?.selDueDateType === 'EONTSELFINSTALL')) {
                            isSetupFeeWaived = false;
                    }   
                }
          
                if( serviceheaditems?.prodName?.includes("Gig") && 
                    (checkoutState?.selDueDateType_new === "EONTSELFINSTALL" || 
                    checkoutState?.selDueDateType === 'EONTSELFINSTALL') && 
                    checkoutState?.accordionStatus?.creditCheck==="completed") {
                        isSetupFeeWaived =false;
                }
          
                if(buildProductState?.internet?.isFeeWaivedForAll) {
                    isSetupFeeWaived =true;
                }
            }
        });
    } 
  
    const onCartSplitBillClicks = (action) => {
        cartActions.splitBillTab(action, dispatch)
    } 

    const handleTabKeyDown= (e, index) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            onCartSplitBillClicks(index);
        }
    }  

    return ( <React.Fragment>
        <div>
            <div className={"orderSubmitPadding bg-white"}>

                {isClassicalFlow ? <ul role="tablist" 
                    className = "w_tabs w_tabs_reskin m_cart-view m_equal-width scroll-shadow tileContent123"
                    data-tabs="" 
                    data-xscroll="" 
                    aria-hidden="false" 
                    style={{position:isMobile?'relative':''}}>
                    {getClassicalHeader()}
                </ul> : ''}
                
                <div id="newCompareCart" >

                    { ((profileServiceHeaders && profileDataService) || (serviceHeaders && dataService)) &&
                    <ContentServiceRenderComp
                    mainTitle={'Internet plan'}
                    mainHeaderSection={getInternetServiceHeader()}
                    splitBillTab={dataService ? splitBillTab : profileSplitBillTab} 
                    listItems = {getInternetSubList()}
                    showCaretIcon="true"           
                    horizontalLine = "true"
                    id="Internet"
                    priceColor="green" 
                    price={`$${(profileDataService ? currentInternetSecTotalPrice : internetSecTotalPrice)?.toFixed(2)}/mo`} 
                    classicFlowType={(isClassicalFlow && (profileClassicDoublePlay || profileClassicTriplePlay || classicDoublePlay || classicTriplePlay))}
                    />}

                    { ((profileServiceHeaders && profileVideoService) || (serviceHeaders && videoService)) && 
                    <ContentServiceRenderComp
                    mainTitle={'Live TV'}
                    mainHeaderSection={getTVServiceHeader()}
                    splitBillTab={videoService ? splitBillTab : profileSplitBillTab} 
                    listItems = {getTVSubList()}
                    showCaretIcon="true"   
                    horizontalLine = {(isClassicalFlow && (profileClassicDoublePlay || profileClassicTriplePlay || classicDoublePlay || classicTriplePlay)) ? "false" : "true"}
                    id="Tv"
                    priceColor="green" 
                    price={ `$${(profileVideoService ? currentTvSecTotalPrice : tvSecTotalPrice)?.toFixed(2)}/mo` }
                    classicFlowType={(isClassicalFlow && (profileClassicDoublePlay || profileClassicTriplePlay || classicDoublePlay || classicTriplePlay))}  
                    />}
                    
                    { ((profileServiceHeaders && profileVoiceService) || (serviceHeaders && voiceService)) &&
                    <ContentServiceRenderComp
                    mainTitle={'Home phone'}
                    mainHeaderSection={getVoiceServiceHeader()}   
                    splitBillTab={voiceService ? splitBillTab : profileSplitBillTab} 
                    listItems = {getVoiceSubList()}
                    showCaretIcon="true"   
                    horizontalLine = {(isClassicalFlow && (profileClassicDoublePlay || profileClassicTriplePlay || classicDoublePlay || classicTriplePlay)) ? "false" : "true"}
                    id="Voice"
                    priceColor="green"  
                    price={`$${(profileVoiceService ? currentVoiceSecTotalPrice : voiceSecTotalPrice)?.toFixed(2)}/mo`}
                    classicFlowType={(isClassicalFlow && (profileClassicDoublePlay || profileClassicTriplePlay || classicDoublePlay || classicTriplePlay))}
                    />} 
                </div> 
            </div>
        </div>
    </React.Fragment> );
}

const mapStateToProps = state => {
    return {
      lqState: state.loopQual,
      appState: state.app,       
      buildProductState: state.buildProduct,  
      saveState:state.save,  
      cartRedState: state.cart,  
      cartProfileState: state.profileCart, 
      checkoutState: state.checkout,
      modalWindowState: state.modalWindow,     
      buildProductState: state.buildProduct,     
      cust_optState: state.moveExp.cust_opt,
      moveExpState: state.moveExp,
      socState: state.firstbill,
      visitId: state.app.visitId,          
    }
  }
export default React.memo(connect(mapStateToProps)(NewCompareCartModal));
